export default {
  routes: [
    {
      name: 'ztest',
      title: 'ztest',
      path: '/ztest',
      component: resolve => require(['./ztest'], resolve)
    },
    {
      name: 'doc',
      title: '肿瘤医生',
      path: '/doc/:id',
      component: resolve => require(['./Doc'], resolve),
      meta: { pageViewStrategy: 'component' }
    },
    {
      name: 'DocSignIn',
      title: '肿瘤医生',
      path: '/DocSignIn/:id/:type',
      component: resolve => require(['./DocSignIn'], resolve)
    },
    {
      name: 'DocPreview',
      title: '文章详情预览',
      path: '/DocPreview/:id',
      component: resolve => require(['./DocPreview'], resolve),
      meta: { pageViewStrategy: 'component' }
    },
    {
      name: 'DocPreviewNew',
      title: '文章详情预览',
      path: '/DocPreviewNew/:id',
      component: resolve => require(['./DocPreviewNew'], resolve),
      meta: { pageViewStrategy: 'component' }
    },
    {
      name: 'LivePreview',
      title: '公开课预览',
      path: '/LivePreview/:id',
      component: resolve => require(['./LivePreview'], resolve),
      meta: { pageViewStrategy: 'component' }
    },
    {
      name: 'LivePreviewNew',
      title: '公开课预览',
      path: '/LivePreviewNew/:id',
      component: resolve => require(['./LivePreviewNew.vue'], resolve),
      meta: { pageViewStrategy: 'component' }
    },
    {
      name: 'list',
      title: '列表',
      path: '/list/:id',
      component: resolve => require(['./List'], resolve)
    },
    {
      name: 'DocVote',
      title: '文章投票',
      path: '/DocVote/:id',
      component: resolve => require(['./DocVote'], resolve)
    },
    {
      name: 'subjectDetail',
      title: '专题详情',
      path: '/subjectDetail/:id',
      component: resolve => require(['./SubjectDetail'], resolve)
    },
    {
      name: 'subjectList',
      title: '专题列表',
      path: '/subjectList',
      component: resolve => require(['./SubjectList'], resolve)
    },
    {
      name: 'subjectBlockList', //专栏版块,和专题列表一样，只是需要id
      title: '板块专题列表',
      path: '/subjectBlockList/:id',
      component: resolve => require(['./SubjectList'], resolve)
    },
    {
      name: 'columnList',
      title: '专栏列表',
      path: '/columnList',
      component: resolve => require(['./ColumnList'], resolve)
    },
    {
      name: 'columnListSubscribed',
      title: '已订阅专栏列表',
      path: '/columnList/:isSubscribed',
      component: resolve => require(['./ColumnList'], resolve)
    },
    {
      name: 'columnList56',
      title: '专栏',
      path: '/columnList56',
      component: resolve => require(['./ColumnList56'], resolve)
    },
    {
      name: 'column',
      title: '专栏详情', //新专栏详情
      path: '/column/:id',
      component: resolve => require(['./Column'], resolve),
      meta: { pageViewStrategy: 'component' }
    },
    {
      name: 'columnDocList',
      title: '', // 专栏文章列表
      path: '/ColumnDocList/:id/:type',
      component: resolve => require(['./ColumnDocList'], resolve)
    },
    {
      name: 'ColumnFansranklist',
      title: '专栏粉丝', //专栏粉丝榜
      path: '/ColumnFansranklist/:id',
      component: resolve => require(['./ColumnFansranklist'], resolve)
    },
    {
      name: 'ColumnIntercfanslist',
      title: '互动粉丝榜单', //专栏粉丝榜
      path: '/ColumnIntercfanslist/:id',
      component: resolve => require(['./ColumnIntercfanslist'], resolve)
    },
    {
      name: 'doctorPage',
      title: '专家详情',
      path: '/doctorPage/:id',
      component: resolve => require(['./DoctorPage'], resolve)
    },
    {
      name: 'subject',
      title: '专题详情', //专题详情
      path: '/subject/:id',
      component: resolve => require(['./Subject'], resolve),
      meta: { pageViewStrategy: 'component' }
    },
    {
      name: 'diagnosis',
      title: '会诊中心',
      path: '/diagnosis',
      component: resolve => require(['./Diagnosis'], resolve)
    },
    {
      name: 'dgDoctorList',
      title: '专家列表',
      path: '/dgDoctorList',
      component: resolve => require(['./DgDoctorList'], resolve)
    },
    {
      name: 'ClinicalRecruitment',
      title: '临床试验招募',
      path: '/clinicalRecruitment',
      component: resolve => require(['./ClinicalRecruitment'], resolve),
    },
    {
      name: 'live',
      title: '公开课',
      path: '/live/:id',
      component: resolve => require(['./Live'], resolve),
      meta: { pageViewStrategy: 'component' },
    },
    {
      name: 'livet',
      title: '公开课',
      path: '/live/:id/:tid',
      component: resolve => require(['./Live'], resolve),
    },
    {
      name: 'FtsLive',
      title: '公开课',
      path: '/FtsLive/:id',
      component: resolve => require(['@/activityPage/FutashuLive/FtsLive'], resolve),
    },
    {
      name: 'Auth',
      title: '权限提示',
      path: '/auth/:id',
      component: resolve => require(['./Auth'], resolve),
    },

    {
      path: '/',
      name: 'Index',
      // title: '良医汇-肿瘤资讯',
      title: '肿瘤医生',
      component: resolve => require(['./Index'], resolve),
    },
    {
      path: '/index',
      name: 'Index2',
      title: '良医汇-肿瘤资讯',
      component: resolve => require(['./Index'], resolve),
    },
    {
      path: '/search',
      name: 'Search',
      title: '搜索',
      component: resolve => require(['./Search'], resolve),
    },
    {
      path: '/searchResult',
      name: 'SearchResult',
      title: '搜索结果',
      component: resolve => require(['./SearchResult'], resolve),
    },
    {
      path: '/adddoctor/:id',
      name: 'AddDoctor',
      title: '添加医生',
      component: resolve => require(['./AddDoctor.vue'], resolve),
    },
    {
      path: '/liveList',
      name: 'LiveList',
      title: '公开课列表',
      component: resolve => require(['./LiveList'], resolve),
    },
    {
      path: '/caseList',
      name: 'CaseList',
      title: '病例列表',
      component: resolve => require(['./CaseList'], resolve),
    },
    {
      path: '/hotNews',
      name: 'HotNews',
      title: '本周最热',
      component: resolve => require(['./HotNews'], resolve),
    },
    {
      path: '/35under35',
      name: 'Vote',
      title: 'CSCO20周年系列活动',
      component: resolve => require(['./activityPage/under35.vue'], resolve),
    },
    {
      path: '/2018under35',
      name: 'newVote',
      title: '35under35',
      component: resolve => require(['./activityPage/2018under35.vue'], resolve),
    },
    {
      // path: '/2019under35/:id',//专栏id
      path: '/2019under35', //专栏id
      name: 'Vote2019',
      title: '35under35',
      component: resolve => require(['./activityPage/2019under35.vue'], resolve),
    },
    {
      path: '/2020under35',
      name: 'Vote2020',
      title: '35under35',
      component: resolve => require(['./activityPage/2020under35.vue'], resolve),
    },
    {
      path: '/2021under35',
      name: 'Vote2021',
      title: '35under35',
      component: resolve => require(['./activityPage/2021under35/2021under35.vue'], resolve),
    },
    {
      path: '/2021under35Detail/:id',
      name: 'Vote2021Detail',
      title: '35under35',
      component: resolve => require(['./activityPage/2021under35/2021under35Detail.vue'], resolve),
    },
    {
      path: '/2022under35',
      name: 'Vote2022',
      title: '35under35',
      component: resolve => require(['./activityPage/2022under35/2022under35.vue'], resolve),
    },
    {
      path: '/2022under35Detail/:id',
      name: 'Vote2022Detail',
      title: '35under35',
      component: resolve => require(['./activityPage/2022under35/2022under35Detail.vue'], resolve),
    },
    {
      path: '/historyImg/:id',
      name: 'historyImg',
      title: '35under35',
      component: resolve => require(['./activityPage/2021under35/historyImg.vue'], resolve),
    },
    {
      path: '/2021under35GrandCeremony',
      name: 'under35GrandCeremony',
      title: 'CSCO25周年活动',
      component: resolve => require(['./activityPage/2021under35/2021under35GrandCeremony'], resolve),
    },
    {
      path: '/2021under35GrandCeremonyOrderDeatil/:type', //通过类型查询奖品详情  type:3 累计三天 type:7 累计七天
      name: 'under35GrandCeremonyOrderDeatil',
      title: 'CSCO25周年活动',
      component: resolve => require(['./activityPage/2021under35/2021under35GrandCeremonyOrderDeatil'], resolve),
    },
    {
      path: '/2021under35GrandCeremonyOrderList',
      name: 'under35GrandCeremonyOrderList',
      title: 'CSCO25周年活动',
      component: resolve => require(['./activityPage/2021under35/2021under35GrandCeremonyOrderList'], resolve),
    },
    {
      path: '/2019under35/:id', //专栏id
      // path: '/2019under35',//专栏id
      name: 'Vote2019pk',
      title: '35under35',
      component: resolve => require(['./activityPage/2019under35pk.vue'], resolve),
    },
    {
      path: '/2019under35/:id/:type', //type:1来自健康时报
      name: 'Vote2019ty',
      title: '35under35',
      component: resolve => require(['./activityPage/2019under35pk.vue'], resolve),
    },
    {
      path: '/CasesVoting',
      name: 'CasesVoting',
      title: '2018“美例秀秀”启示录：哪个病例让您恍然大悟？',
      component: resolve => require(['./activityPage/CasesVoting.vue'], resolve),
    },
    {
      path: '/learnHistory',
      name: 'LearningHistory',
      title: '学习记录',
      component: resolve => require(['./LearningHistory.vue'], resolve),
    },
    {
      path: '/login',
      name: 'Login',
      title: '绑定您的微信',
      component: resolve => require(['./Login/WxLogin.vue'], resolve),
    },
    {
      path: '/invite/:code/:name',
      name: 'AppInviteRegister',
      title: '邀请注册',
      component: resolve => require(['./Login/AppInviteRegister.vue'], resolve),
    },
    {
      path: '/mlogin/:id',
      name: 'mlogin',
      title: '手机登录',
      component: resolve => require(['./Login/Login.vue'], resolve),
    },
    {
      path: '/login/usertype',
      component: resolve => require(['./Login/UserType.vue'], resolve),
      name: 'UserType',
      title: '身份选择',
    },
    {
      path: '/login/RapidEnrollment/:id',
      component: resolve => require(['./Login/RapidEnrollment.vue'], resolve),
      name: 'RapidEnrollment',
      title: '快速登录',
    },
    {
      path: '/login/subscribe',
      component: resolve => require(['./Login/Subscribe.vue'], resolve),
      name: 'Subscribe',
      title: '兴趣选择',
    },
    {
      path: '/login/common',
      component: resolve => require(['./Login/index.vue'], resolve),
      name: 'LoginCommon',
      title: '手机号密码登录',
    },
    {
      path: '/userInfo',
      component: resolve => require(['./UserInfo.vue'], resolve),
      name: 'UserInfo',
      title: '个人信息',
    },
    {
      path: '/academicUserInfo',
      component: resolve => require(['./academicUserInfo.vue'], resolve),
      name: 'academicUserInfo',
      title: '加载中',
    },
    {
      path: '/pcProject',
      component: resolve => require(['./pcProject.vue'], resolve),
      name: 'pcProject',
      title: '肿瘤医生',
      meta: { pageViewStrategy: 'none' },
    },
    {
      path: '/answerDetail/:id',
      component: resolve => require(['./answerDetail.vue'], resolve),
      name: 'Question',
      title: '回答详情',
    },

    {
      path: '/question/:id',
      component: resolve => require(['./questionDetail.vue'], resolve),
      name: 'Question1',
      title: '问题详情',
    },
    {
      path: '/userInfo/hospital',
      component: resolve => require(['./Auth/Hospital.vue'], resolve),
      name: 'userHospital',
      title: '个人信息',
    },
    {
      path: '/userInfo/addHospital',
      component: resolve => require(['./Auth/addHospital.vue'], resolve),
      name: 'userAddHospital',
      title: '个人信息',
    },
    {
      path: '/userInfo/school',
      component: resolve => require(['./Auth/School.vue'], resolve),
      name: 'userSchool',
      title: '个人信息',
    },
    {
      path: '/test',
      component: resolve => require(['./components/Placeholder.vue'], resolve),
      name: 'Placeholder',
      title: '个人信息',
    },
    {
      path: '/mySubscribe',
      component: resolve => require(['./MySubscribe.vue'], resolve),
      name: 'MySubscribe',
      title: '我的订阅',
    },
    {
      path: '/history',
      component: resolve => require(['./History.vue'], resolve),
      name: 'History',
      title: '阅读历史',
    },
    {
      path: '/readList',
      component: resolve => require(['./readList.vue'], resolve),
      name: 'readList',
      title: '阅读排行榜',
    },

    {
      path: '/followuofrequecy',
      component: resolve => require(['./FollowUpFrequency.vue'], resolve),
      name: 'FollowUpFrequency',
      title: '随访频率',
    },
    {
      path: '/setFollowUpPaper/:id',
      component: resolve => require(['./SetFollowUpPaper.vue'], resolve),
      name: 'SetFollowUpPaper',
      title: '设置问卷',
    },
    {
      path: '/setFollowUpList',
      component: resolve => require(['./SetFollowUpList.vue'], resolve),
      name: 'SetFollowUpList',
      title: '设置问卷',
    },
    {
      path: '/identify',
      component: resolve => require(['./Auth/index.vue'], resolve),
      name: 'Identification',
      title: '我的认证',
      children: [{
        path: 'usertype',
        component: resolve => require(['./Auth/UserType.vue'], resolve),
      },
      {
        path: 'edit',
        component: resolve => require(['./Auth/EditProfile.vue'], resolve),
      },
      {
        path: 'edit/hospital',
        title: '填写单位',
        name: 'Hospital',
        component: resolve => require(['./Auth/Hospital.vue'], resolve),
      },
      {
        path: 'edit/school',
        title: '填写学校',
        name: 'School',
        component: resolve => require(['./Auth/School.vue'], resolve),
      },
      {
        path: 'edit/addHospital',
        component: resolve => require(['./Auth/addHospital.vue'], resolve),
        name: 'addHospital',
        title: '填写医院'
      },
      {
        path: 'upload',
        component: resolve => require(['./Auth/UploadIdcard.vue'], resolve),
      },
      {
        path: 'info',
        title: '我的认证',
        name: 'AuthInfo',
        component: resolve => require(['./Auth/Info.vue'], resolve),
      },
      {
        path: 'rzone',
        title: '填写信息',
        name: 'rzone',
        component: resolve => require(['./Auth/rzone.vue'], resolve),
      },
      {
        path: 'PersonalInfo',
        title: '填写信息',
        name: 'PersonalInfo',
        component: resolve => require(['./Auth/PersonalInfo.vue'], resolve),
      },
      {
        path: 'PersonalInfo/complete',
        title: '填写信息',
        name: 'PersonalInfo',
        component: resolve => require(['./Auth/PersonalInfo.vue'], resolve),
      },
      {
        path: 'AuthDisease',
        title: '填写信息',
        name: 'AuthDisease',
        component: resolve => require(['./Auth/disease.vue'], resolve),
      },

      {
        path: 'rztwo',
        title: '上传证件',
        name: 'rztwo',
        component: resolve => require(['./Auth/rztwo.vue'], resolve),
      },
      {
        path: 'rzprivilege',
        title: '认证特权',
        name: 'rzprivilege',
        component: resolve => require(['./Auth/rzprivilege.vue'], resolve),
      },
      {
        path: 'SecurityCode',
        title: '验证码',
        name: 'SecurityCode',
        component: resolve => require(['./Auth/SecurityCode.vue'], resolve),
      },
      ],
    },
    {
      path: '/questionarepreivew/:type/:id',
      component: resolve => require(['./QuestionarePreview.vue'], resolve),
      name: 'QuestionarePreivew',
      title: '查看问卷',
    },
    {
      path: '/followupDetail/:id',
      component: resolve => require(['./followupDetail.vue'], resolve),
      name: 'followupDetail',
      title: '问卷结果',
    },
    {
      path: '/followupinfo/:id',
      component: resolve => require(['./FollowUpInfo.vue'], resolve),
      name: 'followupinfo',
      title: '随访信息',
    },
    {
      path: '/csco',
      name: 'Csco',
      component: resolve => require(['@/pages/Index'], resolve),
      title: 'CSCO',
    },
    {
      path: '/cscobms',
      name: 'Cscobms',
      component: resolve => require(['@/pages/Bms'], resolve),
      title: 'Cscobms',
    },
    {
      path: '/csco/hall',
      name: 'Hall',
      component: resolve => require(['@/pages/Hall/Hall'], resolve),
      title: '虚拟展厅',
    },
    {
      path: '/csco/company/:id',
      name: 'Company',
      component: resolve => require(['@/pages/Hall/Company'], resolve),
      title: '公司展页',
    },
    {
      path: '/csco/meeting',
      name: 'Meeting',
      component: resolve => require(['@/pages/Meeting/Meeting.vue'], resolve),
      title: '最佳卫星会',
    },
    {
      path: '/csco/ppt',
      name: 'PPT',
      component: resolve => require(['@/pages/Meeting/ppt.vue'], resolve),
      title: '最佳卫星会',
    },
    {
      path: '/Membership',
      name: 'Membership',
      component: resolve => require(['./Membership'], resolve),
      title: '会员说明',
    },
    {
      path: '/HongbaoDetail/:id',
      name: 'HongbaoDetail',
      component: resolve => require(['./HongbaoDetail.vue'], resolve),
      title: '红包详情',
    },
    {
      path: '/HongbaoMyRecords',
      name: 'HongbaoMyRecords',
      component: resolve => require(['./HongbaoMyRecords.vue'], resolve),
      title: '收到的红包',
    },
    {
      path: '/HongbaoDetail/:id/:type',
      name: 'HongbaoDetailType',
      component: resolve => require(['./HongbaoDetail.vue'], resolve),
      title: '红包详情',
    },
    {
      path: '/HongbaoMyRecords/:type',
      name: 'HongbaoMyRecordsType',
      component: resolve => require(['./HongbaoMyRecords.vue'], resolve),
      title: '收到的红包',
    },
    {
      path: '/HongbaoStrategies',
      name: 'HongbaoStrategies',
      component: resolve => require(['./HongbaoStrategies.vue'], resolve),
      title: '红包攻略',
    },
    {
      path: '/HongbaoQuestions',
      name: 'HongbaoQuestions',
      component: resolve => require(['./HongbaoQuestions.vue'], resolve),
      title: '常见问题',
    },
    {
      path: '/PayChangeDetail',
      name: 'PayChangeDetail',
      component: resolve => require(['./payChangedetail.vue'], resolve),
      title: '零钱明细',
    },
    {
      path: '/classifyNewList/:filterId',
      name: 'classifyNewList',
      component: resolve => require(['./classifyNewList.vue'], resolve),
      title: '',
    },
    {
      path: '/Bms/:id',
      name: 'Bms',
      component: resolve => require(['./Bms.vue'], resolve),
      title: 'BMS',
    },
    {
      path: '/HospitalHomepage/:id',
      name: 'HospitalHomepage',
      component: resolve => require(['./HospitalHomepage.vue'], resolve),
      title: '医院主页',
    },
    {
      path: '/OfficeHomepage/:id',
      name: 'OfficeHomepage',
      component: resolve => require(['./OfficeHomepage.vue'], resolve),
      title: '科室主页',
    },
    {
      path: '/Consultation/:id/:category', // id 医生id(非会诊id)/团队id ; category 1:医院; 2:科室; 3:团队; 4:医生; 5:联盟
      name: 'Consultation',
      component: resolve => require(['./Consultation.vue'], resolve),
      title: '申请会诊',
    },
    {
      path: '/EditConsultation/:id/:category/:conId', // id 医生id(非会诊id)/团队id ; category 1:医院; 2:科室; 3:团队; 4:医生; 5:联盟 // conId 保存草稿的会诊ID
      name: 'EditConsultation',
      component: resolve => require(['./Consultation.vue'], resolve),
      title: '申请会诊',
    },
    {
      path: '/AllHospital',
      name: 'AllHospital',
      component: resolve => require(['./AllHospital.vue'], resolve),
      title: '全部医院',
    },
    {
      path: '/AllOffice',
      name: 'AllOffice',
      component: resolve => require(['./AllOffice'], resolve),
      title: '全部科室',
    },
    {
      path: '/sciencelibrary/:orgId/:actionType',
      name: 'sciencelibrary',
      component: resolve => require(['./components/office/Sciencelibrary.vue'], resolve),
      title: '科普文库',
    },
    {
      path: '/hospitalintorduce/:id',
      name: 'hospitalintorduce',
      component: resolve => require(['./components/hospital/hospitalintorduce.vue'], resolve),
      title: '医院介绍',
    },
    {
      path: '/officeintroduce/:id',
      name: 'officeintroduce',
      component: resolve => require(['./components/office/officeintroduce.vue'], resolve),
      title: '科室介绍',
    },
    {
      path: '/officeAnnouncement/:id',
      name: 'officeAnnouncement',
      component: resolve => require(['./components/office/officeAnnouncement.vue'], resolve),
      title: '科室公告',
    },
    {
      path: '/hospitalAnnouncement/:id',
      name: 'hospitalAnnouncement',
      component: resolve => require(['./components/hospital/hospitalAnnouncement.vue'], resolve),
      title: '医院公告',
    },
    {
      name: 'DoctorHomePage',
      path: '/DoctorHomePage/:id',
      component: resolve => require(['./DoctorHomePage.vue'], resolve),
      title: '',
    },
    {
      name: 'DoctorConsultationRate',
      title: '会诊评价',
      path: '/DoctorConsultationRate/:id',
      component: resolve => require(['./DoctorConsultationRate.vue'], resolve),
    },
    {
      name: 'TeamConsultationRate',
      title: '会诊评价',
      path: '/TeamConsultationRate/:id',
      component: resolve => require(['./DoctorConsultationRate.vue'], resolve),
    },
    {
      name: 'DoctorCareer',
      title: '执业经历',
      path: '/DoctorCareer/:id',
      component: resolve => require(['./DoctorCareer.vue'], resolve),
    },
    {
      name: 'DoctorWorkingTimes',
      title: '出诊时间',
      path: '/DoctorWorkingTimes/:id',
      component: resolve => require(['./DoctorWorkingTimes.vue'], resolve),
    },
    {
      name: 'DoctorVote',
      title: '投一票',
      path: '/DoctorVote/:doctorId/:consultationId',
      component: resolve => require(['./DoctorVote.vue'], resolve),
    },
    {
      name: 'TeamVote',
      title: '投一票',
      path: '/TeamVote/:teamId', // doctorId指teamid
      component: resolve => require(['./DoctorVote.vue'], resolve),
    },
    {
      name: 'ConsultationPatients',
      title: '选择患者',
      path: '/ConsultationPatients/:patientId',
      component: resolve => require(['./components/Consultation/ConsultationPatients.vue'], resolve),
    },
    {
      name: 'Consultationdetail',
      title: '会诊详情',
      path: '/Consultationdetail/:consultationId/:consType', // 会诊详情 1收到 2申请的 3患者 4审批
      component: resolve => require(['./components/Consultation/Consultationdetail.vue'], resolve),
    },
    {
      name: 'PatientsPay',
      title: '患者支付',
      path: '/PatientsPay/:consultationId/:status', // status 1 会诊申请，第一次进入  2 订单详情第二次进入

      component: resolve => require(['./PatientsPay.vue'], resolve),
      beforeRouteLeave: (to, from, next) => {
        if (window.Interval) {
          clearInterval(window.Interval)
        }
      },
    },
    {
      name: 'PaySuccess',
      title: '提交成功',
      path: '/PaySuccess/:consultationId/:status', //status 0 没有支付
      component: resolve => require(['./PaySuccess.vue'], resolve),
    },
    {
      name: 'ConsultationSuggest',
      title: '会诊建议',
      path: '/ConsultationSuggest/:consultationId/:actionType',
      component: resolve => require(['./components/Consultation/ConsultationSuggest.vue'], resolve),
    },
    {
      name: 'DoctorConsultationNoticeList',
      title: '会诊列表',
      path: '/DoctorConsultationNoticeList/:id', // id 1 收到的会诊列表 2 发起的会诊列表
      component: resolve => require(['./DoctorConsultationNoticeList.vue'], resolve),
    },
    {
      name: 'QuestionBank',
      title: '答题详情',
      path: '/QuestionBank/:eventId/:paperId', //
      component: resolve => require(['./QuestonBank.vue'], resolve),
      beforeRouteLeave: (to, from, next) => {
        if (window.Interval) {
          clearInterval(window.Interval)
        }
      },
    },
    {
      name: 'QuestionRank',
      title: '排行榜',
      path: '/QuestionRank/:eventId/:paperId',
      component: resolve => require(['./QuestionRank.vue'], resolve),
    },
    {
      name: 'QuizExamDetail',
      title: '试题详情',
      path: '/QuizExamDetail/:id',
      component: resolve => require(['./QuizExamDetail.vue'], resolve),
    },
    {
      name: 'QuizPaperList',
      title: '试卷列表',
      path: '/QuizPaperList/:id', // 活动id
      component: resolve => require(['./QuizPaperList.vue'], resolve),
    },
    {
      name: 'QuizActivityDetail',
      title: '活动详情',
      path: '/QuizActivityDetail/:eventId/:paperId/:userAuth2/:dumb',
      component: resolve => require(['./QuizActivityDetail.vue'], resolve),
    },

    {
      name: 'KCLActivityDetail',
      title: '活动详情',
      path: '/KCLActivityDetail/:eventId/:paperId/:userAuth2/:dumb',
      component: resolve => require(['./activityPage/KCLQuestion/KCLActivityDetail'], resolve),
    },
    {
      name: 'KCLPaperList',
      title: '试卷列表',
      path: '/KCLPaperList/:id', // 活动id
      component: resolve => require(['./activityPage/KCLQuestion/KCLPaperList'], resolve),
    },
    {
      name: 'KCLExamDetail',
      title: '试题详情',
      path: '/KCLExamDetail/:id',
      component: resolve => require(['./activityPage/KCLQuestion/KCLExamDetail'], resolve),
    },
    {
      name: 'KCLQuestionBank',
      title: '答题详情',
      path: '/KCLQuestionBank/:eventId/:paperId',
      component: resolve => require(['./activityPage/KCLQuestion/KCLQuestionBank.vue'], resolve),
      beforeRouteLeave: (to, from, next) => {
        if (window.Interval) {
          clearInterval(window.Interval)
        }
      },
    },
    {
      name: 'KCLQuestionRank',
      title: '排行榜',
      path: '/KCLQuestionRank/:eventId/:paperId',
      component: resolve => require(['./activityPage/KCLQuestion/KCLQuestionRank.vue'], resolve),
    },

    {
      name: 'AudioDetial',
      title: '音频详情',
      path: '/AudioDetial/:docId/:audioId/:play/:progress',
      component: resolve => require(['./components/Audio/AudioDetial.vue'], resolve),
    },

    {
      name: 'jurisdictionUsertype',
      title: '选择身份',
      path: '/jurisdictionUsertype',
      component: resolve => require(['./jurisdiction/userType.vue'], resolve),
    },
    {
      name: 'jurisdictionInfoBack',//提交信息后，返回上个页面
      title: '完善信息',
      path: '/jurisdictionInfo/:isFromOPlus', //isFromOPlus:1 表示是从O+活动来的，提交信息后返回上个页面
      component: resolve => require(['./jurisdiction/jurisdictionInfo.vue'], resolve),
    },
    {
      name: 'jurisdictionInfo',
      title: '完善信息',
      path: '/jurisdictionInfo/:userType/:hospital/:universityName', //userType 身份类型 1医生 2企业 3患者 4其他 5医学生 6科研  hospital 医院名字 0不是从医院选择列表进入 universityName 学校名字 0不是从学校选择列表进入
      component: resolve => require(['./jurisdiction/jurisdictionInfo.vue'], resolve),
    },
    {
      name: 'jurisdictionHospital',
      title: '完善信息',
      path: '/jurisdictionHospital',
      component: resolve => require(['./jurisdiction/jurisdictionHospital.vue'], resolve),
    },
    {
      name: 'jurisdictionaddHospital',
      title: '完善信息',
      path: '/jurisdictionaddHospital',
      component: resolve => require(['./jurisdiction/jurisdictionaddHospital.vue'], resolve),
    },
    {
      name: 'jurisdictionDisease',
      title: '完善信息',
      path: '/jurisdictionDisease',
      component: resolve => require(['./jurisdiction/jurisdictionDisease.vue'], resolve),
    },
    {
      name: 'jurisdictionSchool',
      title: '完善信息',
      path: '/jurisdictionSchool',
      component: resolve => require(['./jurisdiction/jurisdictionSchool.vue'], resolve),
    },
    {
      name: 'ArticleCommentDetail',
      title: '评论详情', // 文章的评论
      path: '/ArticleCommentDetail/:docId',
      component: resolve => require(['./ArticleCommentDetail.vue'], resolve),
    },
    {
      name: 'MeetingCommentDetail',
      title: '评论详情', // 会议的评论
      path: '/ArticleCommentDetail/:docId/:listType', // listType: 3 会议评论列表
      component: resolve => require(['./ArticleCommentDetail.vue'], resolve),
    },
    {
      name: 'PowerPointIntro',
      title: 'PPT简介',
      path: '/PowerPointIntro/:pptId/:sharedUserId',
      component: resolve => require(['./PowerPointIntro'], resolve),
    },
    {
      name: 'PowerPointDetail',
      title: 'PPT详情',
      path: '/PowerPointDetail/:pptId',
      component: resolve => require(['./PowerPointDetail'], resolve),
    },
    {
      name: 'MeetingListWithId',
      title: '会议列表',
      path: '/MeetingList/:id',
      component: resolve => require(['./MeetingList.vue'], resolve),
    },
    {
      name: 'MeetingList',
      title: '会议列表',
      path: '/MeetingList',
      component: resolve => require(['./MeetingList.vue'], resolve),
    },
    {
      name: 'MyMeeting',
      title: '我的会议',
      path: '/MyMeeting',
      component: resolve => require(['./MyMeeting.vue'], resolve),
    },
    {
      name: 'MeetingDetail',
      title: '会议',
      path: '/conference/:id',
      component: resolve => require(['./MeetingDetail.vue'], resolve),
    },
    {
      name: 'MeetingDetailEmpty',
      title: '会议详情',
      path: '/MeetingDetailEmpty',
      component: resolve => require(['./MeetingDetailEmpty.vue'], resolve),
    },
    {
      name: 'NewDoctorHomePage',
      title: '',
      path: '/NewDoctorHomePage/:id',
      component: resolve => require(['./NewDoctorHomePage.vue'], resolve),
    },
    {
      name: 'NewTeamHomePage',
      title: '团队主页',
      path: '/NewTeamHomePage/:id',
      component: resolve => require(['./NewTeamHomePage.vue'], resolve),
    },
    {
      name: 'NewUnionHomePage',
      title: '医联体主页',
      path: '/NewUnionHomePage/:id',
      component: resolve => require(['./NewUnionHomePage.vue'], resolve),
    },
    {
      name: 'NewHospitalHomePage',
      title: '医院主页',
      path: '/NewHospitalHomePage/:hospitalId',
      component: resolve => require(['./NewHospitalHomePage.vue'], resolve),
    },

    {
      name: 'NewHospitalProfile',
      title: '医院简介',
      path: '/NewHospitalProfile/:hospitalId',
      component: resolve => require(['./NewHospitalProfile.vue'], resolve),
    },
    {
      name: 'NewUnionIntroduction',
      title: '医联体简介',
      path: '/NewUnionIntroduction/:id',
      component: resolve => require(['./NewUnionIntroduction.vue'], resolve),
    },
    {
      name: 'NewDoctorIntroduction',
      title: '个人简介',
      path: '/NewDoctorIntroduction/:id',
      component: resolve => require(['./NewDoctorIntroduction.vue'], resolve),
    },
    {
      name: 'NewDepartmentProfile',
      title: '科室简介',
      path: '/NewDepartmentProfile/:departmentId',
      component: resolve => require(['./NewDepartmentProfile.vue'], resolve),
    },
    {
      name: 'NewDepartmentHomePage',
      title: '科室主页',
      path: '/NewDepartmentHomePage/:departmentId',
      component: resolve => require(['./NewDepartmentHomepage.vue'], resolve),
    },

    {
      name: 'NewGlobalRemoteConsultPage',
      title: '全球会诊中心',
      path: '/NewGlobalRemoteConsultPage',
      component: resolve => require(['./NewGlobalRemoteConsultPage.vue'], resolve),
    },
    {
      name: 'NewExpertTeamList',
      title: '专家团队',
      path: '/NewExpertTeamList',
      component: resolve => require(['./NewExpertTeamList.vue'], resolve),
    },
    // diseaseId: 0,疾病id ; provinceId:0,省份id或者标识'国外'id(471) ; cityId:0,城市id、外国国家id ; hospitalId:0,医院id
    {
      name: 'NewExpertTeamListFilter',
      title: '专家团队',
      path: '/NewExpertTeamListFilter/:diseaseId/:provinceId/:cityId/:hospitalId',
      component: resolve => require(['./NewExpertTeamList.vue'], resolve),
    },
    //和上面的NewExpertTeamListFilter一样的，只是名字不一样
    {
      name: 'NewExpertTeamListFilterExtend',
      title: '找团队',
      path: '/NewExpertTeamListFilterExtend/:diseaseId/:provinceId/:cityId/:hospitalId',
      component: resolve => require(['./NewExpertTeamList.vue'], resolve),
    },

    {
      name: 'NewConsultationhistory',
      title: '历史记录',
      path: '/NewConsultationhistory/:id',
      component: resolve => require(['./NewConsultationhistory.vue'], resolve),
    },
    {
      name: 'CaseHomepage',
      title: '活动详情',
      path: '/CaseHomepage',
      component: resolve => require(['./CaseChallenge/homepage.vue'], resolve),
    },
    {
      name: 'CaseCompleteinfo',
      title: '完善信息',
      path: '/CaseCompleteinfo',
      component: resolve => require(['./CaseChallenge/CompleteInfo.vue'], resolve),
    },
    {
      name: 'CaseLogin',
      title: '验证手机',
      path: '/CaseLogin',
      component: resolve => require(['./CaseChallenge/login.vue'], resolve),
    },
    {
      name: 'CaseBank',
      title: '病例题库',
      path: '/CaseBank/:id', //caseId
      component: resolve => require(['./CaseChallenge/bank.vue'], resolve),
    },
    {
      name: 'CaseReadbank',
      title: '病例题库',
      path: '/CaseReadbank/:id', //caseId
      component: resolve => require(['./CaseChallenge/readbank.vue'], resolve),
    },
    {
      name: 'CaseResult',
      title: '病例结果',
      path: '/CaseResult/:caseId/:answerRecordId',
      component: resolve => require(['./CaseChallenge/result.vue'], resolve),
    },
    {
      name: 'CaseRank',
      title: '赛季排行',
      path: '/CaseRank/:eventId/:seasonId/:caseId',
      component: resolve => require(['./CaseChallenge/rank.vue'], resolve),
    },
    {
      name: 'SelectCase',
      title: '选择病例',
      path: '/SelectCase',
      component: resolve => require(['./CaseChallenge/SelectCase.vue'], resolve),
    },
    {
      name: 'OldselectCase',
      title: '选择病例',
      path: '/OldselectCase',
      component: resolve => require(['./CaseChallenge/OldselectCase.vue'], resolve),
    },
    {
      name: 'ShareCaseChallenge',
      title: '活动邀请',
      path: '/ShareCaseChallenge/:shareType/:seasonId/:caseId/:userId/:userAuth2/:dumb', // shareType 0活动首页 1病例成绩 2赛季成绩 3总榜
      component: resolve => require(['./CaseChallenge/ShareCaseChallenge.vue'], resolve),
    },
    {
      name: 'DoctorListPage',
      title: '医生列表',
      path: '/DoctorListPage/:diseaseId/:hospitalId',
      component: resolve => require(['./DoctorListPage.vue'], resolve),
    },
    {
      name: 'LYGTestPage',
      title: 'YG测试页面',
      path: '/LYGTestPage',
      component: resolve => require(['./LYGTestPage.vue'], resolve),
    },
    {
      name: 'LYGTestPage2',
      title: 'YG测试页面',
      path: '/LYGTestPage/:param1/:param2',
      component: resolve => require(['./LYGTestPage.vue'], resolve),
    },
    {
      name: 'LYGTestPageOne',
      title: 'YG测试页面一',
      path: '/LYGTestPageOne',
      component: resolve => require(['./LYGTestPageOne.vue'], resolve),
    },
    {
      name: 'LYGTestPageTwo',
      title: 'YG测试页面二',
      path: '/LYGTestPageTwo',
      component: resolve => require(['./LYGTestPageTwo.vue'], resolve),
    },
    {
      name: 'LYGTestPageThree',
      title: 'YG测试页面三',
      path: '/LYGTestPageThree',
      component: resolve => require(['./LYGTestPageThree'], resolve),
    },
    {
      name: 'WeChatAuthorize',
      title: '微信授权',
      path: '/WeChatAuthorize',
      component: resolve => require(['./WeChatAuthorize.vue'], resolve),
    },
    {
      name: 'BMICompute',
      title: '身体质量指数',
      path: '/BMICompute',
      redirect: '/tools/formula/bmi',
      meta: { isToolsPage: true }
    },
    {
      name: 'TumorLevel1',
      title: '选择瘤肿',
      path: '/TumorLevel1',
      component: resolve => require(['./TNM/TumorLevel1.vue'], resolve),
    },
    {
      name: 'TumorSelect',
      title: '选择瘤肿',
      path: '/TumorSelect', //契约中的catalogId用不到的，unionid是未解码的
      component: resolve => require(['./ChemoTherapy/TumorSelect.vue'], resolve),
    },

    {
      name: 'chemoProject',
      title: '方案主页',
      path: '/chemoProject/:id', //契约中的catalogId用不到的
      component: resolve => require(['./ChemoTherapy/chemoProject.vue'], resolve),
    },

    {
      name: 'SelectedTumorPage',
      title: '选择治疗情景',
      path: '/SelectedTumorPage/:parentId',
      component: resolve => require(['./ChemoTherapy/SelectedTumorPage.vue'], resolve),
    },

    {
      name: 'TumorBluePrintList',
      title: '选择方案',
      path: '/TumorBluePrintList/:catalogId',
      component: resolve => require(['./ChemoTherapy/TumorBluePrintList.vue'], resolve),
    },

    {
      name: 'MyCollectList',
      title: '我的收藏',
      path: '/MyCollectList',
      component: resolve => require(['./ChemoTherapy/MyCollectList.vue'], resolve),
    },

    {
      name: 'NewMedicineGuide',
      title: '新药指导',
      path: '/NewMedicineGuide',
      component: resolve => require(['./NewMedicineGuide/NewMedicineGuide.vue'], resolve),
    },
    {
      name: 'AddRecord',
      title: '新建病案',
      path: '/AddRecord/:id/:patientId', //id ，patientId都为0 新患者新病案 ；id：非o，patientId：0 修改病案 id：0，patientId:非0 已有患者添加病案
      component: resolve => require(['./EleMedicalrecord/AddRecord.vue'], resolve),
    },
    {
      name: 'RecordProgresslist',
      title: '诊疗记录',
      path: '/RecordProgresslist/:id',
      component: resolve => require(['./EleMedicalrecord/RecordProgresslist.vue'], resolve),
    },
    {
      name: 'MyTaskList',
      title: '我的任务',
      path: '/MyTaskList',
      component: resolve => require(['./MyTask/MyTaskList.vue'], resolve),
    },
    {
      name: 'CreditMall',
      title: '积分商城',
      path: '/CreditMallPage',
      component: resolve => require(['./CreditMall/CreditMall.vue'], resolve),
    },
    {
      name: 'CreditDetail',
      title: '积分明细',
      path: '/CreditDetail',
      component: resolve => require(['./CreditMall/CreditDetail.vue'], resolve),
    },
    {
      name: 'CreditMallProcuctDetail',
      title: '商品详情',
      path: '/CreditMallProcuctDetail/:giftId',
      component: resolve => require(['./CreditMall/CreditMallProcuctDetail.vue'], resolve),
    },
    {
      name: 'CreditMallOrderInfo',
      title: '确认订单',
      path: '/CreditMallOrderInfo/:giftId',
      component: resolve => require(['./CreditMall/CreditMallOrderInfo.vue'], resolve),
    },
    {
      name: 'BackCreditMallOrderInfo',
      title: '确认订单',
      path: '/CreditMallOrderInfo/:giftId/:type',
      component: resolve => require(['./CreditMall/CreditMallOrderInfo.vue'], resolve),
    },
    {
      name: 'CreditMallOrderList',
      title: '我的订单',
      path: '/CreditMallOrderList',
      component: resolve => require(['./CreditMall/CreditMallOrderList.vue'], resolve),
    },
    {
      name: 'ProductRefund',
      title: '退款申请',
      path: '/ProductRefund/:id',
      component: resolve => require(['./CreditMall/ProductRefund.vue'], resolve),
    },
    {
      name: 'NewExpertList',
      title: '找专家',
      path: '/NewExpertList',
      component: resolve => require(['./NewExpertListPage.vue'], resolve),
    },

    {
      name: 'NewYLTList',
      title: '医联体',
      path: '/NewYLTList',
      component: resolve => require(['./NewYLTListPage.vue'], resolve),
    },

    {
      name: 'ContactDoctorAssistant',
      title: '联系医助',
      path: '/ContactDoctorAssistant',
      component: resolve => require(['./ContactDoctorAssistant.vue'], resolve),
    },
    {
      name: 'DiagnosisGuide',
      title: '临床指南',
      path: '/DiagnosisGuide',
      component: resolve => require(['./DiagnosisGuide/DiagnosisGuide.vue'], resolve),
    },
    {
      name: 'Treatment',
      title: '治疗内容',
      path: '/Treatment/:group/:id/:type/:tnm',
      component: resolve => require(['./DiagnosisGuide/Treatment.vue'], resolve),
    },
    {
      name: 'GKQuestion',
      title: '重回高考',
      path: '/GKQuestion/:shareType', //0 正常 1 分享 2扫码
      component: resolve => require(['./activityPage/GKQuestion/homepage'], resolve),
    },
    {
      name: 'GKanswerList',
      title: '题库',
      path: '/GKanswerList',
      component: resolve => require(['./activityPage/GKQuestion/answerList'], resolve),
    },
    {
      name: 'GKResult',
      title: '成绩单',
      path: '/GKResult/:id',
      component: resolve => require(['./activityPage/GKQuestion/result'], resolve),
    },
    {
      name: 'socialextdetail',
      title: '动态详情',
      path: '/socialextdetail/:id',
      component: resolve => require(['./socialextdetail.vue'], resolve),
    },
    {
      name: 'AnswerQCenter',
      title: '答题中心',
      path: '/AnswerQCenter',
      component: resolve => require(['./AnswerQ/AnswerQCenter.vue'], resolve),
    },
    //答题页面--每日一题、每周复盘、专项答题
    //itemId（ 0:每日一题 ;  非0: 每周复盘或专项答题所对应的id）
    //actionType 对应的是表示是答题还是看解析的（1：表示答题 ；2：表示解析； 3：专项答题不解析、不显示通过再来一次进入的情况）
    //pageType（0：每日一题的答题页 ； 1：每周复盘的答题页  ； 2：专项答题的答题页）
    //index（用于跳转至第几个题目，默认为0）
    {
      name: 'AnswerQDailyAnswerPage',
      title: '答题中心',
      path: '/AnswerQDailyAnswerPage/:itemId/:actionType/:pageType/:index',
      component: resolve => require(['./AnswerQ/AnswerQDailyAnswerPage.vue'], resolve),
    },

    // 每周复盘--首页的列表
    {
      name: 'AnswerQWeekAnalyseList',
      title: '每周复盘',
      path: '/AnswerQWeekAnalyseList',
      component: resolve => require(['./AnswerQ/AnswerQWeekAnalyseList.vue'], resolve),
    },

    //专项答题--首页的列表
    {
      name: 'AnswerQSpecialList',
      title: '专项答题',
      path: '/AnswerQSpecialList',
      component: resolve => require(['./AnswerQ/AnswerQSpecialList.vue'], resolve),
    },

    //答题记录
    {
      name: 'AnswerQRecordList',
      title: '奖励记录',
      path: '/AnswerQRecordList',
      component: resolve => require(['./AnswerQ/AnswerQRecordList.vue'], resolve),
    },

    //每周复盘--结果页
    //isFirstTime（是否是第一次答本题，0:不是第一次答本题  1:表示是）
    {
      name: 'AnswerQWeekReslutPage',
      title: '答题结果',
      path: '/AnswerQWeekReslutPage/:itemId/:isFirstTime',
      component: resolve => require(['./AnswerQ/AnswerQWeekReslutPage.vue'], resolve),
    },

    //专项答题--结果页
    //canReplay（0:不能再重玩一次， 1：可以再重玩一次）
    //isFirstTime（是否是第一次答本题，0:不是第一次答本题  1:表示是）
    //userAuth2 适用于用户分析自己成绩的时候，将自己的auth2带出去，用于他人在打开分享链接的时候获取成绩。
    {
      name: 'AnswerQSpecialReslutPage',
      title: '答题结果',
      path: '/AnswerQSpecialReslutPage/:itemId/:canReplay/:isFirstTime/:userAuth2',
      component: resolve => require(['./AnswerQ/AnswerQSpecialReslutPage.vue'], resolve),
    },

    //每日答题--结果页
    {
      name: 'AnswerQDailyReslutPage',
      title: '答题结果',
      path: '/AnswerQDailyReslutPage/:dtId',
      component: resolve => require(['./AnswerQ/AnswerQDailyReslutPage.vue'], resolve),
    },

    {
      name: 'AnswerQLogin',
      title: '答题结果',
      path: '/AnswerQLogin',
      component: resolve => require(['./AnswerQ/login.vue'], resolve),
    },
    //AZ答题首页
    {
      name: 'AZHomepage',
      title: '活动详情',
      path: '/AZHomepage',
      component: resolve => require(['@/activityPage/AZChallenge/AZHomepage'], resolve),
    },
    {
      name: 'AZSelectCase',
      title: '选择病例',
      path: '/AZSelectCase',
      component: resolve => require(['@/activityPage/AZChallenge/AZSelectCase'], resolve),
    },
    {
      name: 'AZCaseBank',
      title: '病例题库',
      path: '/AZCaseBank/:id', //caseId
      component: resolve => require(['@/activityPage/AZChallenge/AZCaseBank'], resolve),
    },
    {
      name: 'AZCaseResult',
      title: '病例结果',
      path: '/AZCaseResult/:caseId/:answerRecordId/:type', // type 0:获取结果时answerRecordId传0，不去重复记录答题次数  1：获取结果时answerRecordId传值，记录答题次数
      component: resolve => require(['./activityPage/AZChallenge/AZCaseResult'], resolve),
    },
    {
      name: 'AZCaseRank',
      title: '赛季排行',
      path: '/AZCaseRank/:eventId/:seasonId/:caseId',
      component: resolve => require(['./activityPage/AZChallenge/AZCaseRank'], resolve),
    },
    {
      name: 'AZCaseCompleteinfo',
      title: '完善信息',
      path: '/AZCaseCompleteinfo',
      component: resolve => require(['./activityPage/AZChallenge/AZCompleteInfo.vue'], resolve),
    },
    {
      name: 'AZCaseLogin',
      title: '验证手机',
      path: '/AZCaseLogin',
      component: resolve => require(['./activityPage/AZChallenge/AZlogin.vue'], resolve),
    },

    {
      name: 'AZShareCaseChallenge',
      title: '活动邀请',
      path: '/AZShareCaseChallenge/:shareType/:seasonId/:caseId/:userId/:userAuth2/:dumb/:eventId', // shareType 0活动首页 1病例成绩 2赛季成绩 3总榜
      component: resolve => require(['./activityPage/AZChallenge/AZShareCaseChallenge.vue'], resolve),
    },

    //BR答题首页
    {
      name: 'BRHomepage',
      title: '活动详情',
      path: '/BRHomepage',
      component: resolve => require(['@/activityPage/BRCaseChallenge/homepage'], resolve),
    },
    {
      name: 'BRSelectCase',
      title: '选择病例',
      path: '/BRSelectCase',
      component: resolve => require(['@/activityPage/BRCaseChallenge/SelectCase'], resolve),
    },
    {
      name: 'BRCaseBank',
      title: '病例题库',
      path: '/BRCaseBank/:id', //caseId
      component: resolve => require(['@/activityPage/BRCaseChallenge/bank'], resolve),
    },
    {
      name: 'BRCaseResult',
      title: '病例结果',
      path: '/BRCaseResult/:caseId/:answerRecordId', // type 0:获取结果时answerRecordId传0，不去重复记录答题次数  1：获取结果时answerRecordId传值，记录答题次数
      component: resolve => require(['@/activityPage/BRCaseChallenge/result'], resolve),
    },
    {
      name: 'BRCaseRank',
      title: '赛季排行',
      path: '/BRCaseRank/:eventId/:seasonId/:caseId',
      component: resolve => require(['@/activityPage/BRCaseChallenge/rank'], resolve),
    },
    {
      name: 'BRCaseCompleteinfo',
      title: '完善信息',
      path: '/BRCaseCompleteinfo',
      component: resolve => require(['@/activityPage/BRCaseChallenge/CompleteInfo'], resolve),
    },
    {
      name: 'BRCaseLogin',
      title: '验证手机',
      path: '/BRCaseLogin',
      component: resolve => require(['@/activityPage/BRCaseChallenge/login'], resolve),
    },

    {
      name: 'BRShareCaseChallenge',
      title: '活动邀请',
      path: '/BRShareCaseChallenge/:shareType/:seasonId/:caseId/:userId/:userAuth2/:dumb', // shareType 0活动首页 1病例成绩 2赛季成绩 3总榜
      component: resolve => require(['@/activityPage/BRCaseChallenge/ShareCaseChallenge'], resolve),
    },

    {
      name: 'SummaryHomepage',
      title: '肿瘤资讯2019个人总结',
      path: '/SummaryHomepage/:type', //type 埋点区分 0正常 1：二维码扫码
      component: resolve => require(['@/activityPage/Summary/SummaryHomepage'], resolve),
    },

    {
      name: 'SummaryReport',
      title: '肿瘤资讯2019个人总结',
      path: '/SummaryReport',
      component: resolve => require(['@/activityPage/Summary/SummaryReport'], resolve),
    },

    {
      name: 'SummaryResult',
      title: '肿瘤资讯2019个人总结',
      path: '/SummaryResult/:type', //type 正常结果页：0  分享后结果页：sid
      component: resolve => require(['@/activityPage/Summary/SummaryResult'], resolve),
    },

    {
      name: 'PuchaseTip',
      title: '购买须知',
      path: '/purchaseTip',
      component: resolve => require(['./PurchaseTip.vue'], resolve),
    },

    {
      name: 'SettleAccountPage',
      title: '结算',
      path: '/SettleAccountPage/:docId/:purchaseType/:eventId', //docId:公开课的id ;  purchaseType-- 1：购买系列课、 2：购买本单节课 ;eventId:专题的id
      component: resolve => require(['./SettleAccountPage.vue'], resolve),
    },
    {
      name: 'MyCourses',
      title: '我的课程',
      path: '/MyCourses',
      component: resolve => require(['./MyCourses.vue'], resolve),
    },
    {
      name: 'OpenClassVotePage',
      title: '投票',
      path: '/OpenClassVotePage/:docId', //docId：本投票对应的公开课的id
      component: resolve => require(['./OpenClassVotePage.vue'], resolve),
    },
    {
      name: 'iOSPayGuide',
      title: 'iOS支付教程',
      path: '/iOSPayGuide',
      component: resolve => require(['./iOSPayGuide.vue'], resolve),
    },
    {
      name: 'FastConsultList',
      title: '答疑大厅',
      path: '/FastConsultList',
      component: resolve => require(['./FastConsult/FastConsultList.vue'], resolve),
    },
    {
      name: 'FastConsultListForMLink',
      title: '答疑大厅',
      path: '/FastConsultList/:isMLink',
      component: resolve => require(['./FastConsult/FastConsultList.vue'], resolve),
    },
    {
      name: 'FastConsultDetail',
      title: '答疑详情',
      path: '/FastConsultDetail/:id',
      component: resolve => require(['./FastConsult/FastConsultDetail'], resolve),
    },
    {
      name: 'FastConsultDetailOrient',
      title: '答疑详情',
      path: '/FastConsultDetail/:id/:isOrient', //isOrient表示是否是定向提问跳转至详情的，1：是定向提问
      component: resolve => require(['./FastConsult/FastConsultDetail'], resolve),
    },
    {
      name: 'FastHomepage',
      title: '答疑活动主页',
      path: '/FastHomepage',
      component: resolve => require(['./FastConsult/FastHomepage.vue'], resolve),
    },
    {
      name: 'DoctorCard',
      title: '对患者名片',
      path: '/DoctorCard',
      component: resolve => require(['./DoctorCard.vue'], resolve),
    },
    {
      name: 'newpatientlist',
      title: '患者报到',
      path: '/newpatientlist',
      component: resolve => require(['./newpatientlist'], resolve),
    },
    {
      name: 'myfanslist',
      title: '我的粉丝',
      path: '/myfanslist',
      component: resolve => require(['./myfanslist'], resolve),
    },
    {
      name: 'doctorfanslist',
      title: 'TA的粉丝',
      path: '/myfanslist/:id',
      component: resolve => require(['./myfanslist'], resolve),
    },
    {
      name: 'myfocuslist',
      title: '我的关注',
      path: '/myfocuslist',
      component: resolve => require(['./myfocuslist'], resolve),
    },
    {
      name: 'doctorfocuslist',
      title: 'TA的关注',
      path: '/myfocuslist/:id',
      component: resolve => require(['./myfocuslist'], resolve),
    },
    {
      name: 'CommonityBlood',
      title: '亿时代血液肿瘤大咖在线',
      path: '/CommonityBlood/:id/:tId/:thId',
      component: resolve => require(['./CommonityBlood.vue'], resolve),
    },
    {
      name: 'CommonityBloodList',
      title: '大咖阵容',
      path: '/CommonityBloodList/:id/:tId/:thId',
      component: resolve => require(['./CommonityBloodList.vue'], resolve),
    },
    {
      name: 'BloodColumn',
      title: '',
      path: '/BloodColumn/:id',
      component: resolve => require(['./BloodColumn'], resolve),
    },
    {
      name: 'BloodColumnQRCode',
      title: '血液肿瘤医生社群',
      path: '/BloodColumn/:id/:code',
      component: resolve => require(['./BloodColumn'], resolve),
    },
    {
      name: 'ASCOColumn',
      title: '',
      path: '/ASCOColumn/:id',
      component: resolve => require(['./ASCOColumn'], resolve),
    },
    {
      name: 'SignInNoPrevPage',
      title: '暂无权限',
      path: '/SignInNoPrevPage',
      component: resolve => require(['./SignInNoPrevPage'], resolve),
    },
    {
      name: 'StudyQuickSearchManual',
      title: '研究详情',
      path: '/StudyQuickSearchManual/:id',
      component: resolve => require(['./StudyQuickSearchManual/StudyQuickSearchManual'], resolve),
    },
    {
      name: 'SQSMIndex',
      title: '选择瘤种',
      path: '/SQSMIndex',
      component: resolve => require(['./StudyQuickSearchManual/SQSMIndex'], resolve),
    },
    {
      name: 'SQSMIndexid',
      title: '选择瘤种',
      path: '/SQSMIndex/:id',
      component: resolve => require(['./StudyQuickSearchManual/SQSMIndex'], resolve),
    },
    {
      name: 'SQSMFilter',
      title: '筛选',
      path: '/SQSMFilter/:name/:id',
      component: resolve => require(['./StudyQuickSearchManual/SQSMFilter'], resolve),
    },
    {
      name: 'SQSMList',
      title: '选择研究',
      path: '/SQSMList',
      component: resolve => require(['./StudyQuickSearchManual/SQSMList'], resolve),
    },
    {
      name: 'SQSMSearch',
      title: '搜索',
      path: '/SQSMSearch',
      component: resolve => require(['./StudyQuickSearchManual/SQSMSearch'], resolve),
    },
    {
      name: 'MedicationAssistant',
      title: '用药助手',
      path: '/MedicationAssistant',
      component: resolve => require(['./StudyQuickSearchManual/MedicationAssistant'], resolve),
    },
    {
      name: 'applyHomePage',
      title: '肿瘤诊疗黑科技大会',
      path: '/applyHomePage',
      component: resolve => require(['@/activityPage/BlackTechnology/applyHomePage'], resolve),
    },
    {
      name: 'HkjActivityHomePage',
      title: '肿瘤诊疗黑科技大会',
      path: '/HkjActivityHomePage/:tabStatus',
      component: resolve => require(['@/activityPage/BlackTechnology/HKJactivityHomePage'], resolve),
    },
    {
      name: 'HkjJuryPage',
      title: '肿瘤诊疗黑科技大会',
      path: '/HkjJuryPage/:type',
      component: resolve => require(['@/activityPage/BlackTechnology/HkjJuryPage'], resolve),
    },
    {
      name: 'hkjTop20Column',
      title: '肿瘤诊疗黑科技大会',
      path: '/hkjTop20Column/:id',
      component: resolve => require(['./Column'], resolve),
    },
    {
      name: 'contactUs',
      title: '联系我们',
      path: '/contactUs/:id/:userSignId',
      component: resolve => require(['./activityPage/BlackTechnology/contactUs'], resolve),
    },
    {
      name: 'androidpayH5',
      title: 'android微信支付',
      path: '/androidpayH5/:orderTrade/:price',
      component: resolve => require(['./activityPage/BlackTechnology/androidpayH5'], resolve),
    },
    {
      name: 'iospayH5',
      title: 'ios微信支付',
      path: '/iospayH5',
      component: resolve => require(['./activityPage/BlackTechnology/iospayH5'], resolve),
    },
    {
      name: 'caseVoteHomePage',
      title: '病例投票',
      path: '/caseVoteHomePage',
      component: resolve => require(['./activityPage/CaseVote/caseVoteHomePage'], resolve),
    },
    {
      name: 'caseVoteDetail',
      title: '病例详情',
      path: '/caseVoteDetail/:id',
      component: resolve => require(['./activityPage/CaseVote/caseVoteDetail'], resolve),
    },
    {
      name: 'selectionActivityHomePage',
      title: '年度十大评选',
      path: '/selectionActivityHomePage/:type',  //type埋点区分链接还是二维码  0 正常情况  1二维码进入
      component: resolve => require(['./activityPage/SelectionActivity/selectionActivityHomePage'], resolve),
    },
    {
      name: 'selectPage',
      title: '年度十大评选',
      path: '/selectPage/:type',  //type埋点区分链接还是二维码  0 正常情况  1二维码进入
      component: resolve => require(['./activityPage/SelectionActivity/selectPage'], resolve),
    },
    {
      name: 'selectList',
      title: '年度十大评选',
      path: '/selectList/:id/:type',   //type埋点区分链接还是二维码  0 正常情况  1二维码进入
      component: resolve => require(['./activityPage/SelectionActivity/selectList'], resolve),
    },
    {
      name: 'resultPage',
      title: '年度十大评选',
      path: '/resultPage/:type/:ids/:nickName', //type埋点区分链接还是二维码  0 正常情况  1二维码进入
      component: resolve => require(['./activityPage/SelectionActivity/resultPage'], resolve),
    },
    {
      name: 'posterPage',
      title: '年度十大评选',
      path: '/posterPage/:type/:ids/:nickName', //type埋点区分链接还是二维码  0 正常情况  1二维码进入
      component: resolve => require(['./activityPage/SelectionActivity/posterPage'], resolve),
    },
    {
      name: 'CAXCaseVoteH5HomePage',
      title: '首届长安心病例故事大赛',
      path: '/CAXCaseVoteH5HomePage',
      component: resolve => require(['./activityPage/CAXCaseVote/CAXCaseVoteH5HomePage'], resolve),
    },
    {
      name: 'CAXCaseVotePCHomePage',
      title: '首届长安心病例故事大赛',
      path: '/CAXCaseVotePCHomePage',
      component: resolve => require(['./activityPage/CAXCaseVote/CAXCaseVotePCHomePage'], resolve),
    },
    {
      name: 'CAXCaseVoteH5Detail',
      title: '首届长安心病例故事大赛',
      path: '/CAXCaseVoteH5Detail/:id/:type',
      component: resolve => require(['./activityPage/CAXCaseVote/CAXCaseVoteH5Detail'], resolve),
    },
    {
      name: 'CAXCaseVotePCDetail',
      title: '首届长安心病例故事大赛',
      path: '/CAXCaseVotePCDetail/:id/:type',
      component: resolve => require(['./activityPage/CAXCaseVote/CAXCaseVotePCDetail'], resolve),
    },
    {
      name: 'CAXCaseVoteLogin',
      title: '首届长安心病例故事大赛',
      path: '/CAXCaseVoteLogin',
      component: resolve => require(['@/activityPage/CAXCaseVote/CAXCaseVoteLogin'], resolve),
    },
    {
      name: 'CAXCaseVoteH5List',
      title: '首届长安心病例故事大赛',
      path: '/CAXCaseVoteH5List/:type',
      component: resolve => require(['./activityPage/CAXCaseVote/CAXCaseVoteH5List'], resolve),
    },
    {
      name: 'CAXCaseVotePCList',
      title: '首届长安心病例故事大赛',
      path: '/CAXCaseVotePCList/:type',
      component: resolve => require(['./activityPage/CAXCaseVote/CAXCaseVotePCList'], resolve),
    },
    {
      name: 'IHHome',
      title: '全球肿瘤防治中心',
      path: '/IHHome',
      component: resolve => require(['./IH/IHHome'], resolve),
    },
    {
      name: 'IHClinicCenterHome',
      title: '名家名院',
      path: '/IHClinicCenterHome/:id',
      component: resolve => require(['./IH/IHClinicCenterHome'], resolve),
    },
    {
      name: 'IHClinicCenterList',
      title: '全球肿瘤防治中心',
      path: '/IHClinicCenterList/:id',
      component: resolve => require(['./IH/IHClinicCenterList'], resolve),
    },
    {
      name: 'IHHospitalList',
      title: '肿瘤名院',
      path: '/IHHospitalList',
      component: resolve => require(['./IH/IHHospitalList'], resolve),
    },
    {
      name: 'IHGistApplyJoin',
      title: '申请加入',
      path: '/IHGistApplyJoin/:id',
      component: resolve => require(['./IH/IHGistApplyJoin'], resolve),
    },
    {
      name: 'IHStudyCenter',
      title: '学习中心',
      path: '/IHStudyCenter/:id',
      component: resolve => require(['./IH/IHStudyCenter'], resolve),
    },
    {
      name: 'DoctorServiceSetting',
      title: '服务设置',
      path: '/DoctorServiceSetting',
      component: resolve => require(['./DoctorServiceSetting.vue'], resolve),
    },
    {
      name: 'openid',
      title: 'openid',
      path: '/openid',
      component: resolve => require(['./openid'], resolve),
    },
    {
      name: 'IHPicTextConsultation',
      title: '',
      path: '/IHPicTextConsultation',
      component: resolve => require(['./IH/IHPicTextConsultation'], resolve),
    },
    {
      name: 'IHRemoteConsultation',
      title: '远程会诊',
      path: '/IHRemoteConsultation',
      component: resolve => require(['./IH/IHRemoteConsultation'], resolve),
    },
    {
      name: 'IHMultiVideosList',
      title: '会诊列表',
      path: '/IHMultiVideosList/:vtype',
      component: resolve => require(['./IH/IHMultiVideosList.vue'], resolve),
    },
    {
      name: 'IHPatientCase',
      title: '患者病例',
      path: '/IHPatientCase/:id',
      component: resolve => require(['./IH/IHPatientCase'], resolve),
    },
    {
      name: 'IHConAddResult',
      title: '会诊报告',
      path: '/IHConAddResult/:id',
      component: resolve => require(['./IH/IHConAddResult'], resolve),
    },
    {
      name: 'IHOriginDocument',
      title: '文件管理',
      path: '/IHOriginDocument',
      component: resolve => require(['./IH/IHOriginDocument.vue'], resolve),
    },
    {
      name: 'IHPicTextConsultation',
      title: '',
      path: '/IHPicTextConsultation/:type',
      component: resolve => require(['./IH/IHPicTextConsultation'], resolve),
    },
    {
      name: 'IHTelConsultation',
      title: '电话咨询',
      path: '/IHTelConsultation/:id',
      component: resolve => require(['./IH/IHTelConsultation'], resolve),
      props: true // pass route.params to props
    },
    {
      name: 'IHTelConsultationList',
      title: '电话咨询',
      path: '/IHTelConsultationList',
      component: resolve => require(['./IH/IHTelConsultationList'], resolve),
    },
    {
      name: 'IHPatDiseaseDesc',
      title: '快速问答',//快速问答的 接诊 页面
      path: '/IHPatDiseaseDesc/:id',//id: 问诊id
      component: resolve => require(['./IH/IHPatDiseaseDesc'], resolve),
    },
    {
      name: 'IHPatCaseTxtQuery',
      title: '',//图文咨询或问诊的 接诊 页面
      path: '/IHPatCaseTxtQuery/:id',//id: 问诊id
      component: resolve => require(['./IH/IHPatCaseTxtQuery'], resolve),
    },
    {
      name: 'IHPatCaseVideoQuery',
      title: '视频咨询',//视频问诊的 接诊 页面
      path: '/IHPatCaseVideoQuery/:id',//id: 问诊id
      component: resolve => require(['./IH/IHPatCaseVideoQuery'], resolve),
    },
    {
      name: 'IHTestPage',
      title: '弹窗测试',
      path: '/IHTestPage',
      component: resolve => require(['./IH/IHTestPage.vue'], resolve),
    },
    {
      name: 'gastricRes',
      title: '胃癌研学院',
      path: '/gastricRes',
      component: resolve => require(['./CancerRes/gastric.vue'], resolve),
    },
    {
      name: 'CloudInteract',
      title: '云上互动',
      path: '/CloudInteract',
      component: resolve => require(['./CSCO2020/CloudInteract'], resolve),
    },
    {
      name: 'EnterpriseSpace',
      title: '企业空间站',
      path: '/EnterpriseSpace',
      component: resolve => require(['./CSCO2020/EnterpriseSpace'], resolve),
    },
    {
      name: 'MetFirstPage',
      title: '活动详情',
      path: '/MetFirstPage/:id', //id：活动id
      component: resolve => require(['./activityPage/CSCO2020/met/MetFirstPage'], resolve),
    },
    {
      name: 'MetQuestList',
      title: '选择试题', //试题列表
      path: '/MetQuestList/:id', //id：活动id
      component: resolve => require(['./activityPage/CSCO2020/met/MetQuestList'], resolve),
    },
    {
      name: 'MetQuestDesc',
      title: '试题详情', //试题介绍
      path: '/MetQuestDesc/:id', // id：试题id
      component: resolve => require(['./activityPage/CSCO2020/met/MetQuestDesc'], resolve),
    },
    {
      name: 'MetQuesDetail',
      title: '答题', //试题对应的题目页面
      path: '/MetQuesDetail/:eventId/:id', //eventId:活动id  id：试题id
      component: resolve => require(['./activityPage/CSCO2020/met/MetQuesDetail'], resolve),
    },
    {
      name: 'MetSharePage',
      title: '分享', //1、答过题--展示成绩 2、未答过题-展示其他样式
      path: '/MetSharePage/:eventId/:paperId/:auth2',
      component: resolve => require(['./activityPage/CSCO2020/met/MetSharePage'], resolve),
    },
    {
      name: 'MetResult',
      title: '结果', //实力排行和综合排行
      path: '/MetResult',
      component: resolve => require(['./activityPage/CSCO2020/met/MetResult'], resolve),
    },

    {
      name: 'HpkActivityDetail',
      title: '活动详情',
      path: '/HpkActivityDetail/:eventId/:paperId/:userAuth2/:dumb',
      component: resolve => require(['./activityPage/Hpk/HpkActivityDetail'], resolve),
    },
    {
      name: 'HpkPaperList',
      title: '试卷列表',
      path: '/HpkPaperList/:id', // 活动id
      component: resolve => require(['./activityPage/Hpk/HpkPaperList'], resolve),
    },
    {
      name: 'HpkExamDetail',
      title: '试题详情',
      path: '/HpkExamDetail/:eventId/:paperId',
      component: resolve => require(['./activityPage/Hpk/HpkExamDetail'], resolve),
    },
    {
      name: 'HpkQuestionBank',
      title: '答题详情',
      path: '/HpkQuestionBank/:eventId/:paperId',
      component: resolve => require(['./activityPage/Hpk/HpkQuestionBank.vue'], resolve),
      beforeRouteLeave: (to, from, next) => {
        if (window.Interval) {
          clearInterval(window.Interval)
        }
      },
    },
    {
      name: 'HpkQuestionRank',
      title: '排行榜',
      path: '/HpkQuestionRank/:eventId/:paperId',
      component: resolve => require(['./activityPage/Hpk/HpkQuestionRank.vue'], resolve),
    },
    {
      name: 'MyWallet',
      title: '我的钱包',
      path: '/MyWallet',
      component: resolve => require(['./withdraw/MyWallet'], resolve),
    },
    {
      name: 'BindBank',
      title: '绑定银行卡',
      path: '/BindBank',
      component: resolve => require(['./withdraw/BindBank'], resolve),
    },
    {
      name: 'Withdraw',
      title: '提现',
      path: '/Withdraw',
      component: resolve => require(['./withdraw/Withdraw'], resolve),
    },
    {
      name: 'IHVideoConsultation',
      title: '',
      path: '/IHVideoConsultation/:type/:id',
      component: resolve => require(['./IH/IHVideoConsultation'], resolve),
    },
    {
      name: 'IHVCAddResult',
      title: '咨询小结',
      path: '/IHVCAddResult/:id',
      component: resolve => require(['./IH/IHVCAddResult'], resolve),
    },
    {
      name: 'IHTreatmentAdv',
      title: '第二诊疗意见',
      path: '/IHTreatmentAdv/:id',
      component: resolve => require(['./IH/IHTreatmentAdv'], resolve),
    },
    {
      name: 'IHVCAddResultChange',
      title: '咨询小结',
      path: '/IHVCAddResult/:type/:id',//type (1：图文问诊  2：视频咨询  8：电话问诊 15:快速问诊)
      component: resolve => require(['./IH/IHVCAddResult'], resolve),
    },
    {
      name: 'IHColumnNwelist',
      title: '学术交流',
      path: '/IHColumnNwelist/:id',
      component: resolve => require(['./IH/IHColumnNwelist'], resolve),
    },
    {
      name: 'MyMedal',
      title: '我的勋章',
      path: '/MyMedal/:medalId', //medalId为0时，不用管；为大于0的数，表示要展示此勋章id对应的勋章详情
      component: resolve => require(['./Medal/MyMedal'], resolve),
    },
    {
      name: 'ShareMedalPage',
      title: '勋章详情', //分享出来的勋章详情页面
      path: '/ShareMedalPage/:userId/:medalId', //userId：分享人的用户id  ；medalId：分享的勋章id
      component: resolve => require(['./Medal/ShareMedalPage'], resolve),
    },
    {
      name: 'MyMedalSharePage',
      title: '我的勋章', //分享出来的勋章墙
      path: '/MyMedalSharePage/:userId', //userId：分享人的用户id
      component: resolve => require(['./Medal/MyMedalSharePage'], resolve),
    },
    {
      name: 'recipeInfo',
      title: '处方详情',
      path: '/recipeInfo/:id/:inquiryId', //id 处方id  inquiry问诊id
      component: resolve => require(['./Recipe/recipeInfo'], resolve),
    },
    {
      name: 'recipeInfoExtend',
      title: '处方详情',
      path: '/recipeInfo/:id/:inquiryId/:sourceType', //id 处方id  inquiry问诊id  sourceType:来源（3：图文咨询 5：电话咨询 6:视频咨询 15:快速问诊） PS：快速问诊弄成15是因为要和小结统一，代码里面会转成8
      component: resolve => require(['./Recipe/recipeInfo'], resolve),
    },
    {
      name: 'IHUserinfoToBjca',
      title: '电子签名',
      path: '/IHUserinfoToBjca/:plat', //plat: 互联网医院平台类型   0：海南  1：成都
      component: resolve => require(['./IH/IHUserinfoToBjca'], resolve),
    },
    {
      name: 'IHUserinfoToBjcaOld',
      title: '电子签名',
      path: '/IHUserinfoToBjca', //老的只支持海南互联网医院平台的路由
      component: resolve => require(['./IH/IHUserinfoToBjca'], resolve),
    },
    {
      name: 'DoctorRecipeList',
      title: '电子处方', //药师--待审核、已审核 的处方列表；医生--待审核、已审核、已驳回 的处方列表
      path: '/DoctorRecipeList/:type', //type:  0:医生  1：药师
      component: resolve => require(['./DoctorRecipeList'], resolve),
    },
    {
      name: 'DoctorRecipeListTab',
      title: '电子处方', //药师--待审核、已审核 的处方列表；医生--待审核、已审核、已驳回 的处方列表
      path: '/DoctorRecipeList/:type/:tabType', //type:  0:医生  1：药师 // tabType:-1待签名 0待审核 1已审核 2已驳回 3已过期
      component: resolve => require(['./DoctorRecipeList'], resolve),
    },
    {
      name: 'SurgicalPlate',
      title: '肿瘤外科',
      path: '/SurgicalPlate',
      component: resolve => require(['./SurgicalPlate'], resolve),
    },
    {
      name: 'UploadSourceData', // EDC上传源数据
      title: '上传源数据',
      path: '/UploadSourceData',
      component: resolve => require(['./ElectronicDataCapture/UploadSourceData'], resolve),
    },
    {
      name: 'UrinaryHomePage', // 中国泌尿肿瘤百强榜--首页
      title: '中国泌尿肿瘤百强榜',
      path: '/UrinaryHomePage',
      component: resolve => require(['./activityPage/Urinary/UrinaryHomePage'], resolve),
    },
    {
      name: 'UrinaryTeamList', // 中国泌尿肿瘤百强榜--团队列表
      title: '专家团队',
      path: '/UrinaryTeamList',
      component: resolve => require(['./activityPage/Urinary/UrinaryTeamList'], resolve),
    },
    {
      name: 'UrinaryTeamPage', //  中国泌尿肿瘤百强榜--团队主页
      title: '团队主页',
      path: '/UrinaryTeamPage/:id',
      component: resolve => require(['./activityPage/Urinary/UrinaryTeamPage'], resolve),
    },
    {
      name: 'UrinaryDoctorList',
      title: '团队成员',
      path: '/UrinaryDoctorList/:id',
      component: resolve => require(['./activityPage/Urinary/UrinaryDoctorList'], resolve),
    },
    {
      name: 'SelectOption', // EDC选择项目
      title: '请选择项目',
      path: '/SelectOption',
      component: resolve => require(['./ElectronicDataCapture/SelectOption'], resolve),
    },
    {
      name: 'AddOption', // EDC发起新项目
      title: '发起新项目',
      path: '/AddOption',
      component: resolve => require(['./ElectronicDataCapture/AddOption'], resolve),
    },
    {
      name: 'SelectSubject', // EDC选择受试者
      title: '请选择受试者',
      path: '/SelectSubject',
      component: resolve => require(['./ElectronicDataCapture/SelectSubject'], resolve),
    },
    {
      name: 'AddSubject', // EDC新建受试者
      title: '新建受试者',
      path: '/AddSubject',
      component: resolve => require(['./ElectronicDataCapture/AddSubject'], resolve),
    },
    {
      name: 'EDChistoryList', // EDC历史记录
      title: '查看历史',
      path: '/EDChistoryList',
      component: resolve => require(['./ElectronicDataCapture/HistoryList'], resolve),
    },
    {
      name: 'SourceData', // EDC数据详情
      title: '查看历史',
      path: '/SourceData/:projectId/:patientRecordId',
      component: resolve => require(['./ElectronicDataCapture/SourceData'], resolve),
    },
    {
      name: 'ScienceVerifyFirst', // EDC 科研资格认证--第一步
      title: '科研资格认证',
      path: '/ScienceVerifyFirst',
      component: resolve => require(['./ElectronicDataCapture/ScienceVerifyFirst'], resolve),
    },
    {
      name: 'ScienceVerifySecond', // EDC 科研资格认证--第二步
      title: '科研资格认证',
      path: '/ScienceVerifySecond',
      component: resolve => require(['./ElectronicDataCapture/ScienceVerifySecond'], resolve),
    },
    {
      name: 'ScienceVerifyThird', // EDC 科研资格认证--第三步
      title: '科研资格认证',
      path: '/ScienceVerifyThird',
      component: resolve => require(['./ElectronicDataCapture/ScienceVerifyThird'], resolve),
    },
    {
      name: 'ScienceVerifyForth', // EDC 科研资格认证--第四步
      title: '科研资格认证',
      path: '/ScienceVerifyForth',
      component: resolve => require(['./ElectronicDataCapture/ScienceVerifyForth'], resolve),
    },
    {
      name: 'ScienceVerifyProtocol', // EDC 科研资格认证--服务协议
      title: '服务协议',
      path: '/ScienceVerifyProtocol',
      component: resolve => require(['./ElectronicDataCapture/ScienceVerifyProtocol'], resolve),
    },
    {
      name: 'ViewContract', // EDC数据详情
      title: '查看合同',
      path: '/ViewContract/:id/:reviseid',//id:项目id  reviseid:用户合同的id
      component: resolve => require(['./ElectronicDataCapture/ViewContract'], resolve),
    },
    {
      name: 'UploadContract', // EDC数据详情
      title: '上传合同',
      path: '/UploadContract',
      component: resolve => require(['./ElectronicDataCapture/UploadContract'], resolve),
    },
    {
      name: 'DownloadContract', // EDC数据详情
      title: '下载合同',
      path: '/DownloadContract',
      component: resolve => require(['./ElectronicDataCapture/DownloadContract'], resolve)
    },
    {
      name: 'EDCHospital', // EDC医院的医院
      title: '所在医院',
      path: '/EDCHospital',
      component: resolve => require(['./ElectronicDataCapture/EDCHospital'], resolve)
    },
    {
      name: 'ScienceVerifyDetail', // EDC认证详情
      title: '科研资格认证',
      path: '/ScienceVerifyDetail',
      component: resolve => require(['./ElectronicDataCapture/ScienceVerifyDetail'], resolve)
    },
    {
      name: 'Community',
      title: '社区',
      path: '/Community',
      component: resolve => require(['./Community.vue'], resolve)
    },
    {
      name: 'IHGistApplyJoinSecond',
      title: '申请加入',
      path: '/IHGistApplyJoinSecond',
      component: resolve => require(['./IH/IHGistApplyJoinSecond'], resolve)
    },
    {
      name: 'IHGistApplyJoinThird',
      title: '申请加入',
      path: '/IHGistApplyJoinThird',
      component: resolve => require(['./IH/IHGistApplyJoinThird'], resolve)
    },
    {
      name: 'LuckyDraw',
      title: '好礼大派送',
      path: '/LuckyDraw',
      component: resolve => require(['./prize/LuckyDraw'], resolve)
    },
    {
      name: 'PrizeList',
      title: '我的奖品',
      path: '/PrizeList',
      component: resolve => require(['./prize/PrizeList'], resolve)
    },
    {
      name: 'PrizeOrderInfo',
      title: '确认订单',
      path: '/PrizeOrderInfo/:id',
      component: resolve => require(['./prize/PrizeOrderInfo'], resolve)
    },
    {
      name: 'HotNewsWX',
      title: '本周最热',
      path: '/HotNewsWX',
      component: resolve => require(['./hotNewsXW.vue'], resolve)
    },
    {
      name: 'academicDoc',
      title: '肿瘤医生',
      path: '/academicDoc/:id/:packageId/:detailId/:ifFinished/:token',
      component: resolve => require(['./Doc'], resolve),
    },
    {
      name: 'academicLive',
      title: '公开课',
      path: '/academicLive/:id/:packageId/:detailId/:ifFinished/:token',
      component: resolve => require(['./Live'], resolve),
    },
    {
      name: 'ClinicalGuide',
      title: '临床指南',
      path: '/ClinicalGuide',
      redirect: '/tools/cpg/list',
      // component: resolve => require(['./ClinicalGuide.vue'], resolve),
    },
    {
      name: 'ClinicalGuideSelect',
      title: '',
      path: '/ClinicalGuideSelect',
      redirect: '/tools/cpg/list',
      // component: resolve => require(['./ClinicalGuideSelect.vue'], resolve),
    },
    {
      name: 'DoctorCardgzt',
      title: '对患者名片',
      path: '/DoctorCardgzt',
      component: resolve => require(['./DoctorCardgzt.vue'], resolve),
    },
    {
      name: 'OtherDoctorCardgzt',
      title: '对患者名片',
      path: '/DoctorCardgzt/:auth2',
      component: resolve => require(['./DoctorCardgzt.vue'], resolve),
    },
    {
      name: 'PatientManual',
      title: '系统介绍',
      path: '/PatientManual',
      component: resolve => require(['./PatientManual.vue'], resolve),
    },
    {
      name: 'MeetingNewsRank',
      title: '会议热榜',
      path: '/MeetingNewsRank',
      component: resolve => require(['./MeetingNewsRanks.vue'], resolve),
    },
    {
      name: 'starProject',
      title: '明星中心',
      path: '/starProject',
      component: resolve => require(['./StarProject.vue'], resolve),
    },
    {
      name: 'MeetingNewRank',
      title: '会议热榜',
      path: '//MeetingNewsRank',
      component: resolve => require(['./MeetingNewsRanks.vue'], resolve),
    },
    {
      name: '2021review',
      title: '2021年终盘点',
      path: '/2021review',
      component: resolve => require(['./activityPage/2021review.vue'], resolve)
    },
    // {
    //   name: 'testNativeAnalysis',
    //   title: 'native链接解析测试页',
    //   path: '/testNativeAnalysis',
    //   component: resolve => require(['./activityPage/testNativeAnalysis.vue'], resolve)
    // },
    {
      name: 'activityHomePage',
      title: '2021年终盘点',
      path: '/activityHomePage',
      component: resolve => require(['@/activityPage/2021yearEndAwards/activityHomePage'], resolve)
    },
    {
      name: 'activityRankList',
      title: '2021年度热词榜单',
      path: '/activityRankList',
      component: resolve => require(['@/activityPage/2021yearEndAwards/activityRankList'], resolve)
    },
    {
      name: 'activitySelectHotWordsPage',
      title: '年度热词',
      path: '/activitySelectHotWordsPage',
      component: resolve => require(['@/activityPage/2021yearEndAwards/activitySelectHotWordsPage'], resolve)
    },
    {
      name: 'BrowserLogin',
      title: '浏览器登录页',
      path: '/BrowserLogin',
      component: resolve => require(['./Login/BrowserLogin.vue'], resolve)
    },
    // 金研奖
    {
      name: 'activityJYJhome',
      title: '金研奖',
      path: '/activityJYJhome',
      component: resolve => require(['./activityPage/activityJYJ/activityJYJhome.vue'], resolve)
    },
    {
      name: 'activityJYJRankingList',
      title: '金研奖',
      path: '/activityJYJRankingList/:id',
      component: resolve => require(['./activityPage/activityJYJ/activityJYJRankingList.vue'], resolve)
    },
    {
      name: 'activityJYJRankList',
      title: '2022第三届金研奖',
      path: '/activityJYJRankList',
      component: resolve => require(['./activityPage/activityJYJ/activityJYJRankList.vue'], resolve)
    },
    {
      name: 'activityJYJ2023',
      title: '2023第四届金研奖',
      path: '/activityJYJ2023',
      component: resolve => require(['./activityPage/activityJYJ/activityJYJhome2023.vue'], resolve)
    },
    {
      name: 'activityJYJ2024',
      title: '2024第五届金研奖',
      path: '/activityJYJ2024',
      component: resolve => require(['./activityPage/activityJYJ/activityJYJhome2024.vue'], resolve)
    },
    {
      name: 'activityJYJ2025',
      title: '2025第六届金研奖',
      path: '/activityJYJ2025',
      component: resolve => require(['./activityPage/activityJYJ/activityJYJhome2025.vue'], resolve)
    },
    {
      name: 'activityJYJModifyVote',
      title: '金研奖投票修改',
      path: '/activityJYJModifyVote',
      component: resolve => require(['./activityPage/activityJYJ/activityJYJModifyVote.vue'], resolve)
    },
    {
      name: 'jyjDoc',
      title: '肿瘤医生',
      path: '/jyjDoc/:taskCode/:type/:integral/:id',
      component: resolve => require(['./Doc'], resolve),
    },
    {
      name: 'jyjLive',
      title: '公开课',
      path: '/jyjLive/:taskCode/:type/:integral/:id',
      component: resolve => require(['./Live'], resolve),
    },
    {
      name: 'RTCompetition',
      title: '【人气PK】出类“靶”萃|2022放疗竞技赛',
      path: '/2021RTCompetition',
      component: resolve => require(['./activityPage/2021RTCompetition/2021RTCompetition'], resolve)
    },
    //2021年新型抗肿瘤药物
    {
      name: 'drugsHome',
      title: 'R1满血版用药助手',
      path: '/drugsHome',
      redirect: '/tools/da/home',
      // component: resolve => require(['@/OCDrugs/drugsHome.vue'], resolve)
      meta: { isToolsPage: true }
    },
    {
      name: 'drugsHomeYear',
      title: '2022年新型抗肿瘤药物',
      path: '/drugsHome/:year',
      redirect: '/tools/da/home/:year',
      // component: resolve => require(['@/OCDrugs/drugsHome.vue'], resolve)
      meta: { isToolsPage: true }
    },
    {
      name: 'R1满血版用药助手',
      title: '2024年新型抗肿瘤药物',
      path: '/drugsResearch',
      redirect: '/tools/da/search',
      // component: resolve => require(['@/OCDrugs/drugsResearch.vue'], resolve)
      meta: { isToolsPage: true }
    },
    {
      name: 'drugsResearchYear',
      title: '2022年新型抗肿瘤药物',
      path: '/drugsResearch/:year',
      redirect: '/tools/da/search/:year',
      // component: resolve => require(['@/OCDrugs/drugsResearch.vue'], resolve)
      meta: { isToolsPage: true }
    },
    {
      name: 'drugsByDisease',
      title: '',
      path: '/drugsByDisease/:id',
      redirect: '/tools/da/disease/:id',
      // component: resolve => require(['@/OCDrugs/drugsByDisease.vue'], resolve)
      meta: { isToolsPage: true, pageViewStrategy: 'component' }
    },
    {
      name: 'drugsByDiseaseYear',
      title: '',
      path: '/drugsByDisease/:id/:year',
      redirect: '/tools/da/disease/:id/:year',
      meta: { isToolsPage: true, pageViewStrategy: 'component' }
      // component: resolve => require(['@/OCDrugs/drugsByDisease.vue'], resolve)
    },
    {
      name: 'drugsDetail',
      title: '',
      path: '/drugsDetail/:id/:type',
      redirect: '/tools/da/detail/:id/:type',
      meta: { isToolsPage: true,
        isNeedShowInfoComplete: true,
        infoCompleteData: {
          belong_page: '用药助手详情页',
          page_source: 'tools_da_detail'
        }
      }
      // component: resolve => require(['@/OCDrugs/drugsDetail.vue'], resolve)
    },
    {
      name: 'drugsDetailYear',
      title: '',
      path: '/drugsDetail/:id/:type/:year',
      redirect: '/tools/da/detail/:id/:type/:year',
      meta: { isToolsPage: true,
        isNeedShowInfoComplete: true,
        infoCompleteData: {
          belong_page: '用药助手详情页',
          page_source: 'tools_da_detail'
        }
      }
      // component: resolve => require(['@/OCDrugs/drugsDetail.vue'], resolve)
    },
    {
      name: 'previewPDF',
      title: '2024年新型抗肿瘤药物',
      path: '/previewPDF/:type',
      redirect: '/tools/da/preview/:type',
      meta: { isToolsPage: true }
      // component: resolve => require(['@/OCDrugs/previewPDF.vue'], resolve)
    },
    {
      name: 'previewPDF',
      title: '2024年新型抗肿瘤药物',
      path: '/previewPDF/:type/:year',
      redirect: '/tools/da/preview/:type/:year',
      meta: { isToolsPage: true }
      // component: resolve => require(['@/OCDrugs/previewPDF.vue'], resolve)
    },
    // 临床科研
    {
      name: 'researchHome',
      title: '临床科研',
      path: '/researchHome',
      component: resolve => require(['@/activityPage/ClinicalResearch/researchHome'], resolve)
    },
    {
      name: 'researchSchool',
      title: '科研学堂',
      path: '/researchSchool',
      component: resolve => require(['@/activityPage/ClinicalResearch/researchSchool'], resolve)
    },
    {
      name: 'researchHighers',
      title: '研究者',
      path: '/researchHighers',
      component: resolve => require(['@/activityPage/ClinicalResearch/researchHighers'], resolve)
    },
    {
      name: 'researchProject',
      title: '科研项目',
      path: '/researchProject',
      component: resolve => require(['@/activityPage/ClinicalResearch/researchProject'], resolve)
    },
    {
      name: 'cooperativeGroup',
      title: '协作组',
      path: '/cooperativeGroup',
      component: resolve => require(['@/activityPage/ClinicalResearch/cooperativeGroup'], resolve)
    },
    {
      name: 'groupDetails',
      title: '协作组',
      path: '/groupDetails',
      component: resolve => require(['@/activityPage/ClinicalResearch/groupDetails'], resolve)
    },
    {
      name: 'centerDetails',
      title: '研究中心',
      path: '/centerDetails',
      component: resolve => require(['@/activityPage/ClinicalResearch/groupDetails'], resolve)
    },
    {
      name: 'teamDetails',
      title: '研究团队',
      path: '/teamDetails',
      component: resolve => require(['@/activityPage/ClinicalResearch/groupDetails'], resolve)
    },
    {
      name: 'PIHome',
      title: '研究者主页',
      path: '/PIHome',
      component: resolve => require(['@/activityPage/ClinicalResearch/PIHome'], resolve)
    },
    {
      name: 'projectDetail',
      title: '项目详情',
      path: '/projectDetail',
      component: resolve => require(['@/activityPage/ClinicalResearch/projectDetail'], resolve)
    },
    {
      name: 'researchCenter',
      title: '研究中心',
      path: '/researchCenter',
      component: resolve => require(['@/activityPage/ClinicalResearch/researchCenter'], resolve)
    },
    {
      name: 'researchTeam',
      title: '研究团队',
      path: '/researchTeam',
      component: resolve => require(['@/activityPage/ClinicalResearch/researchTeam'], resolve)
    },
    {
      name: 'EasternCancerCasesHome',
      title: '东部肿瘤罕见突变联盟',
      path: "/EasternCancerCasesHome",
      component: resolve => require(['./activityPage/EasternCancerCases/EasternCancerCasesHome.vue'], resolve)
    },
    {
      path: '/updateUserInfo/:type/:id',
      component: resolve => require(['./Auth/updateUserInfo.vue'], resolve),
      name: 'updateUserInfo',
      title: '选择科室',
    },
    {
      name: 'answerProjectHome',
      title: '结直肠癌全程管理学院实战营',
      path: '/answerProjectHome/:type',
      component: resolve => require(['@/activityPage/answerProject/answerProjectHome'], resolve)
    },
    {
      name: 'casesAnswer',
      title: '结直肠癌全程管理学院实战营',
      path: '/casesAnswer/:id/:type',
      component: resolve => require(['@/activityPage/answerProject/casesAnswer'], resolve)
    },
    {
      name: 'answerCourse',
      title: '结直肠癌全程管理学院实战营',
      path: '/answerCourse/:type',
      component: resolve => require(['@/activityPage/answerProject/answerCourse'], resolve)
    },
    {
      name: 'getCertificate',
      title: '结直肠癌全程管理学院实战营',
      path: '/getCertificate/:id/:type',
      component: resolve => require(['@/activityPage/answerProject/getCertificate'], resolve)
    },
    {
      name: 'documentIframe',
      title: '限时任务',
      path: '/documentIframe',
      component: resolve => require(['@/documentIframe'], resolve)
    },
    {
      name: 'integralDoc',
      title: '肿瘤医生',
      path: '/integralDoc/:id',
      component: resolve => require(['./Doc'], resolve),
    },
    {
      name: 'integralLive',
      title: '公开课',
      path: '/integralLive/:id',
      component: resolve => require(['./Live'], resolve),
    },
    {
      name: 'informationlist',
      title: '',
      path: '/informationlist/:type/:platId/:index',
      component: resolve => require(['@/activityPage/answerProject/informationlist'], resolve)
    },
    {
      name: 'urologicalTumors',
      title: '第二届中国泌尿肿瘤百强单位',
      path: '/urologicalTumors',
      component: resolve => require(['@/activityPage/urologyDepartment/urologicalTumors'], resolve)
    },
    {
      name: 'urinaryTeamHome',
      title: '',
      path: '/urinaryTeamHome/:id',
      component: resolve => require(['@/activityPage/urologyDepartment/urinaryTeamHome'], resolve)
    },
    {
      name: 'urinaryManagement',
      title: '泌尿百强榜项目数据管理平台',
      path: '/urinaryManagement',
      component: resolve => require(['@/activityPage/urologyDepartment/urinaryManagement'], resolve)
    },
    {
      name: 'urinaryRankingList',
      title: '泌尿肿瘤排行榜',
      path: '/urinaryRankingList',
      component: resolve => require(['@/activityPage/urologyDepartment/urinaryRankingList'], resolve)
    },
    {
      name: 'CSCOHome',
      title: '2022年CSCO指南大会',
      path: '/CSCOHome',
      component: resolve => require(['@/activityPage/CSCO2022guide/CSCOHome'], resolve)
    },
    {
      path: '/AppLiveList',
      name: 'AppLiveList',
      title: '良医汇直播',
      component: resolve => require(['./pages/AppLiveListNew/index'], resolve),
    },
    {
      path: '/AppPlaybackList',
      name: 'AppPlaybackList',
      title: '良医汇直播回顾',
      component: resolve => require(['./pages/AppLiveListNew/backList'], resolve),
    },
    {
      name: 'bayerHome',
      title: '学术思享荟',
      path: '/bayerHome',
      component: resolve => require(['@/activityPage/Bayer2022/bayerHome'], resolve)
    },
    {
      name: 'listPage',
      title: '',
      path: '/listPage/:type',
      component: resolve => require(['@/activityPage/Bayer2022/listPage'], resolve)
    },
    {
      name: 'NewcomerWelfare',
      title: '肿瘤医生三重礼，海量福利等你领',
      path: '/NewcomerWelfare',
      component: resolve => require(['@/activityPage/NewcomerWelfare'], resolve)
    },
    {
      name: 'ASCOHomePage',
      title: 'ASCO福利来袭',
      path: '/ASCOHomePage',
      component: resolve => require(['@/activityPage/2022ASCO/ASCOHomePage'], resolve)
    },
    {
      name: 'ASCOAssistant',
      title: 'ASCO福利来袭',
      path: '/ASCOAssistant/:userId/:userName',
      component: resolve => require(['@/activityPage/2022ASCO/ASCOAssistant'], resolve)
    },
    {
      name: 'academicCreditMall',
      title: '学术大使专属',
      path: '/academicCreditMall',
      component: resolve => require(['@/academicCreditMall/academicCreditMall'], resolve)
    },
    {
      name: 'academicCreditMallProcuctDetail',
      title: '商品详情',
      path: '/academicCreditMallProcuctDetail/:id',//商品id
      component: resolve => require(['@/academicCreditMall/academicCreditMallProcuctDetail'], resolve)
    },
    {
      name: 'academicCreditMallOrderInfo',
      title: '商品订单',
      path: '/academicCreditMallOrderInfo/:id',//商品id
      component: resolve => require(['@/academicCreditMall/academicCreditMallOrderInfo'], resolve)
    },
    {
      name: 'academicCreditMallScoreDetail',
      title: '我的积分',
      path: '/academicCreditMallScoreDetail',
      component: resolve => require(['@/academicCreditMall/academicCreditMallScoreDetail'], resolve)
    },
    {
      name: 'StomachUniversity',
      title: '',
      path: '/StomachUniversity/:id',
      component: resolve => require(['./pages/Stomach'], resolve)
    },
    {
      name: 'newMeetingPage',
      title: '学术会议',
      path: '/newMeetingPage',
      component: resolve => require(['./pages/newMeetingPage/index.vue'], resolve),
    },
    {
      name: 'MeetingCalendar',
      title: '会议日历',
      path: '/MeetingCalendar',
      component: resolve => require(['./pages/NewMeetingCalendar/index'], resolve),
    },
    {
      name: 'HotMeetingPages',
      title: '会议热榜',
      path: '/HotMeetingPages',
      component: resolve => require(['./pages/newMeetingPage/HotMeetingPages.vue'], resolve),
    },
    {
      name: 'MeetingHomePage',
      title: '会议详情',
      path: '/MeetingHomePage/:id',
      component: resolve => require(['./pages/MeetingHomePage/MeetingHomePage.vue'], resolve)
    },
    {
      name: 'HWTActivityPage',
      title: '2024 HOW WE TREAT CANCER',
      path: '/HWTActivityPage',
      component: resolve => require(['@/activityPage/HWTActivityPage/HWTActivityPage'], resolve)
    },
    {
      name: 'HWTActivityExpertPage',
      title: '专家列表',
      path: '/HWTActivityExpertPage',
      component: resolve => require(['@/activityPage/HWTActivityPage/HWTActivityExpertPage'], resolve)
    },
    {
      name: 'academicAmbassadorIntro',
      title: '学术大使介绍',
      path: '/academicAmbassadorIntro',
      component: resolve => require(['./academicAmbassadorIntro.vue'], resolve)
    },
    {
      name: 'IHPatCaseInfo',
      title: '电子病历',
      path: '/IHPatCaseInfo/:id/:inquiryId/:inquiryType', //id 病历id  inquiry问诊id  inquiryType问诊类型（0：图文） PS:有病历id的话，就不需要传inquiryId；否则就传inquiryId
      component: resolve => require(['./IHPatCaseInfo'], resolve),
    },
    {
      name: 'consulationHome',
      title: '专家会诊',
      path: '/consulationHome',
      component: resolve => require(['@/activityPage/consulationList/consulationHome'], resolve)
    },
    {
      name: 'GCPResult',
      title: '考试结果',
      path: '/GCPResult',
      component: resolve => require(['@/activityPage/GCPFindPoint/GCPResult'], resolve)
    },
    {
      name: 'CertificateHome',
      title: '肿瘤医生证书',
      path: '/CertificateHome',
      component: resolve => require(['@/myCertificate/CertificateHome'], resolve)
    },
    {
      name: 'CertificateDetail',
      title: '',
      path: '/CertificateDetail/:docId/:index',
      component: resolve => require(['@/myCertificate/CertificateDetail'], resolve)
    },
    {
      name: 'HTDHome',
      title: 'HOW TO DEVELOP',
      path: '/HTDHome',
      component: resolve => require(['@/activityPage/HTDActivityPage/HTDHome'], resolve)
    },
    {
      name: 'HTDSpecialist',
      title: 'HOW TO DEVELOP',
      path: '/HTDSpecialist',
      component: resolve => require(['@/activityPage/HTDActivityPage/HTDSpecialist'], resolve)
    },
    {
      name: 'HTDConferenceList',
      title: 'HOW TO DEVELOP',
      path: '/HTDConferenceList',
      component: resolve => require(['@/activityPage/HTDActivityPage/HTDConferenceList'], resolve)
    },
    {
      name: 'WxMiniNavigateBack',
      title: '返回',
      path: '/WxMiniNavigateBack',
      component: resolve => require(['./WxMiniNavigateBack'], resolve)
    },
    {
      name: 'IntroductionUpdate',
      title: '新功能介绍',
      path: '/IntroductionUpdate',
      component: resolve => require(['./IntroductionUpdate'], resolve)
    },
    {
      name: 'EditNote',
      title: '写笔记',
      path: '/EditNote/:docid/:time/:noteid',
      component: resolve => require(['@/pages/notes/EditNote'], resolve)
    },
    {
      name: 'EditNote',
      title: '写笔记',
      path: '/EditNote/:docid/:time',
      component: resolve => require(['@/pages/notes/EditNote'], resolve)
    },
    {
      name: 'NoteList',
      title: '我的笔记',
      path: '/NoteList/:docId',
      component: resolve => require(['@/pages/notes/NoteList'], resolve)
    },
    {
      name: 'blackTechnologyHome',
      title: '2023肿瘤黑科技',
      path: '/blackTechnologyHome',
      component: resolve => require(['@/activityPage/2022BlackTechnology/blackTechnologyHome'], resolve)
    },
    {
      name: 'projectExhibition',
      title: '项目展厅',
      path: '/projectExhibition/:type',
      component: resolve => require(['@/activityPage/2022BlackTechnology/projectExhibition'], resolve)
    },
    {
      name: 'conferenceDetails',
      title: '2023肿瘤黑科技',
      path: "/conferenceDetails",
      component: resolve => require(['@/activityPage/2022BlackTechnology/conferenceDetails'], resolve)
    },
    {
      name: 'projectDetails',
      title: '项目详情页',
      path: '/projectDetails/:types/:ids',
      component: resolve => require(['@/activityPage/2022BlackTechnology/projectDetails'], resolve)
    },
    {
      name: 'popularList',
      title: '2023肿瘤黑科技',
      path: '/popularList',
      component: resolve => require(['@/activityPage/2022BlackTechnology/popularList'], resolve)
    },
    {
      name: 'meetJudge',
      title: '大会评委',
      path: '/meetJudge/:index',
      component: resolve => require(['@/activityPage/2022BlackTechnology/meetJudge'], resolve)
    },
    {
      name: "enterpriseExhibition",
      title: "企业展厅",
      path: '/enterpriseExhibition/:type',
      component: resolve => require(['@/activityPage/2022BlackTechnology/enterpriseExhibition'], resolve)
    },
    {
      name: "enterpriseDetails",
      title: "企业展厅主页",
      path: '/enterpriseDetails/:types/:ids',
      component: resolve => require(['@/activityPage/2022BlackTechnology/enterpriseDetails'], resolve)
    },
    {
      name: "searchBlackPro",
      title: "2023肿瘤黑科技",
      path: "/searchBlackPro",
      component: resolve => require(['@/activityPage/2022BlackTechnology/searchBlackPro'], resolve)
    },
    {
      name: "zlysReply",
      title: "肿瘤医生客服",
      path: "/zlysReply",
      component: resolve => require(['@/pages/App/ZLYSReply'], resolve)
    },
    {
      name: 'NewFeedBack',
      title: '意见反馈',
      path: '/NewFeedBack',
      component: resolve => require(['./NewFeedBack'], resolve)
    },
    , {
      name: 'NewFeedBackHistory',
      title: '意见反馈',
      path: '/NewFeedBackHistory',
      component: resolve => require(['./NewFeedBackHistory'], resolve)
    },
    {
      name: 'NewFeedBackProblems',
      title: '常见问题',
      path: '/NewFeedBackProblems',
      component: resolve => require(['./NewFeedBackProblems'], resolve)
    },
    {
      name: 'NewFeedBackProblemsTwo',
      title: '常见问题',
      path: '/NewFeedBackProblems/:type',
      component: resolve => require(['./NewFeedBackProblems'], resolve)
    },
    {
      name: '2022ActivityHomePage',
      title: '2022肿瘤资讯年终盘点',
      path: '/2022ActivityHomePage',
      component: resolve => require(['@/activityPage/2022yearEndAwards/activityHomePage'], resolve)
    },
    {
      name: '2022activityRankList',
      title: '2022肿瘤资讯年终盘点',
      path: '/2022activityRankList',
      component: resolve => require(['@/activityPage/2022yearEndAwards/activityRankList'], resolve)
    },
    {
      name: '2022actityDrugDetail',
      title: '',
      path: '/2022actityDrugDetail/:id',
      component: resolve => require(['@/activityPage/2022yearEndAwards/actityDrugDetail'], resolve)
    },
    {
      name: "webViewInit",
      title: "WebViewInit",
      path: "/webViewInit",
      component: resolve => require(['@/pages/App/WebViewInit'], resolve),
      meta: { pageViewStrategy: 'none' }
    },
    {
      name: "WLXSHome",
      title: "唯来学社",
      path: "/WLXSHome",
      component: resolve => require(['@/activityPage/WLXSActivityPage/WLXSHome'], resolve)
    },
    {
      name: 'WLXSSpecialist',
      title: '唯来学社导师风采',
      path: '/WLXSSpecialist',
      component: resolve => require(['@/activityPage/WLXSActivityPage/WLXSSpecialist'], resolve)
    },
    {
      name: 'WLXSStudentsStyle',
      title: '唯来学社学员风采',
      path: '/WLXSStudentsStyle',
      component: resolve => require(['@/activityPage/WLXSActivityPage/WLXSStudentsStyle'], resolve)
    },
    {
      name: 'WLXSConferenceList',
      title: '唯来学社活动集锦',
      path: '/WLXSConferenceList',
      component: resolve => require(['@/activityPage/WLXSActivityPage/WLXSConferenceList'], resolve)
    },
    {
      name: "integratedAnimation",
      title: "",
      path: "/integratedAnimation",
      component: resolve => require(['./integratedAnimation'], resolve)
    },
    {

      name: 'WLXSVoteHome',
      title: '投票主页',
      path: '/WLXSVoteHome',
      component: resolve => require(['@/activityPage/WLXSActivityPage/WLXSVoteHome'], resolve)
    },
    {
      name: 'WLXSVoteDetails',
      title: '我的投票',
      path: '/WLXSVoteDetails/:index',
      component: resolve => require(['@/activityPage/WLXSActivityPage/WLXSVoteDetails/'], resolve)
    },
    {
      name: 'WLXSVoteResults',
      title: '投票结果',
      path: '/WLXSVoteResults/:index',
      component: resolve => require(['@/activityPage/WLXSActivityPage/WLXSVoteResults'], resolve)
    },
    {
      name: 'OuterLinkPage',
      title: '',
      path: '/OuterLinkPage',
      component: resolve => require(['./MyTask/OuterLinkPage.vue'], resolve)
    },
    {
      name: 'LyhMLink',
      title: '',
      path: '/LyhMLink/:routePath',
      component: resolve => require(['./LyhMLink'], resolve)
    },
    {
      name: 'turnplateRaffle',
      title: '',
      path: '/turnplateRaffle/:code',
      component: resolve => require(['./raffle/turnplateRaffle'], resolve)
    },
    {
      name: 'ninePalaceRaffle',
      title: '',
      path: '/ninePalaceRaffle/:code',
      component: resolve => require(['./raffle/ninePalaceRaffle'], resolve)
    },
    {
      name: 'myPrizeList',
      title: '我的奖品',
      path: '/myPrizeList/:code',
      component: resolve => require(['./raffle/myPrizeList'], resolve)
    },
    {
      name: 'prizeOrderInfoPage',
      title: '确认订单',
      path: '/prizeOrderInfoPage/:id/:code',
      component: resolve => require(['./raffle/prizeOrderInfo'], resolve)
    },
    // 2023默克答题
    {
      name: '2023answerProjectHome',
      title: '结直肠癌全程管理学院实战营',
      path: '/2023answerProjectHome/:type',
      component: resolve => require(['@/activityPage/2023answerProject/answerProjectHome'], resolve)
    },
    {
      name: '2023answerCourse',
      title: '结直肠癌全程管理学院实战营',
      path: '/2023answerCourse/:type',
      component: resolve => require(['@/activityPage/2023answerProject/answerCourse'], resolve)
    },
    {
      name: '2023casesAnswer',
      title: '结直肠癌全程管理学院实战营',
      path: '/2023casesAnswer/:id/:type',
      component: resolve => require(['@/activityPage/2023answerProject/casesAnswer'], resolve)
    },
    {
      name: '2023getCertificate',
      title: '结直肠癌全程管理学院实战营',
      path: '/2023getCertificate/:id/:type',
      component: resolve => require(['@/activityPage/2023answerProject/getCertificate'], resolve)
    },
    {
      name: '2023informationlist',
      title: '',
      path: '/2023informationlist/:type/:platId/:index',
      component: resolve => require(['@/activityPage/2023answerProject/informationlist'], resolve)
    },
    {
      name: 'mokedevelopment',
      title: '结直肠癌全程管理学院实战营',
      path: '/mokedevelopment',
      component: resolve => require(['@/activityPage/2023answerProject/development'], resolve)
    },
    {
      name: 'mokeCommunity',
      title: '社区互动',
      path: '/mokeCommunity/:type',
      component: resolve => require(['@/activityPage/2023answerProject/mokeCommunity'], resolve)
    },
    {
      name: 'mokeCommunityDetail',
      title: '社区互动',
      path: '/mokeCommunityDetail/:uuid/:type',
      component: resolve => require(['@/activityPage/2023answerProject/mokeCommunityDetail'], resolve)
    },
    {
      name: 'issueNewCommunity',
      title: '发布新动态',
      path: '/issueNewCommunity/:type',
      component: resolve => require(['@/activityPage/2023answerProject/issueNewCommunity'], resolve)
    },
    {
      name: 'learnAmbassador',
      title: '学习大使',
      path: '/learnAmbassador',
      component: resolve => require(['@/learnAmbassador/index'], resolve)
    },
    {
      name: 'myDoctors',
      title: '我的医生',
      path: '/myDoctors',
      component: resolve => require(['@/learnAmbassador/myDoctors'], resolve)
    },
    {
      name: 'learnAmbUnbindDoctorList',
      title: '待绑定医生',
      path: '/learnAmbUnbindDoctorList',
      component: resolve => require(['@/learnAmbassador/learnAmbUnbindDoctorList'], resolve)
    },
    {
      name: 'interSituation',
      title: '互动情况',
      path: '/interSituation',
      component: resolve => require(['@/learnAmbassador/interSituation'], resolve)
    },
    {
      name: 'dataBase',
      title: '资料库',
      path: '/dataBase',
      component: resolve => require(['@/learnAmbassador/dataBase'], resolve)
    },
    {
      name: 'dataBaseList',
      title: '资料列表',
      path: '/dataBaseList',
      component: resolve => require(['@/learnAmbassador/dataBaseList'], resolve)
    },
    {
      name: 'ambMeeting',
      title: '会议列表',
      path: '/ambMeeting',
      component: resolve => require(['@/learnAmbassador/ambMeeting'], resolve)
    },
    {
      name: 'interactionTask',
      title: '互动任务',
      path: '/interactionTask',
      component: resolve => require(['@/learnAmbassador/interactionTask'], resolve)
    },
    {
      name: 'ambIframe',
      title: '任务详情',
      path: '/ambIframe',
      component: resolve => require(['@/learnAmbassador/ambIframe'], resolve)
    },
    {
      name: 'ambNaire',
      title: '问卷',
      path: '/ambNaire',
      component: resolve => require(['@/learnAmbassador/ambNaire'], resolve)
    },
    {
      name: 'ambRanking',
      title: '排行榜',
      path: '/ambRanking',
      component: resolve => require(['@/learnAmbassador/ambRanking'], resolve)
    },
    {
      name: 'ambTopRanking',
      title: '排行榜',
      path: '/ambTopRanking',
      component: resolve => require(['@/learnAmbassador/ambTopRanking'], resolve)
    },
    {
      name: 'ambShareRank',
      title: '排行榜',
      path: '/ambShareRank',
      component: resolve => require(['@/learnAmbassador/ambShareRank'], resolve)
    },
    {
      name: 'FilePreview',
      title: '文件预览',
      path: '/FilePreview/:id', //文件id
      component: resolve => require(['./FilePreview'], resolve)
    },
    {
      name: 'FileEmpty',
      title: '空白页',
      path: '/FileEmpty/:source',
      component: resolve => require(['./FileEmpty'], resolve)
    },
    {
      name: 'youthResearch',
      title: '青年研说家',
      path: '/youthResearch',
      component: resolve => require(['@/activityPage/youthResearch/youthResearch'], resolve)
    },
    {
      name: 'academicQuesAnswer',
      title: '肿瘤学术问答（Beta）',
      path: '/academicQuesAnswer',
      component: resolve => require(['@/activityPage/academicQuesAnswer/index'], resolve)
    },
    {
      name: 'academicQuick',
      title: '快速问答',
      path: '/academicQuick/:id',
      component: resolve => require(['@/activityPage/academicQuesAnswer/academicQuick'], resolve)
    },
    {
      name: 'academicAskQuest',
      title: '提问',
      path: '/academicAskQuest/:id',
      component: resolve => require(['@/activityPage/academicQuesAnswer/academicAskQuest'], resolve)
    },
    {
      name: 'academicQuestDetail',
      title: '肿瘤学术问答（Beta）',
      path: '/academicQuestDetail/:id',
      component: resolve => require(['@/activityPage/academicQuesAnswer/academicQuestDetail'], resolve)
    },
    {
      name: 'academicAnswerDetail',
      title: '肿瘤学术问答（Beta）',
      path: '/academicAnswerDetail/:id',
      component: resolve => require(['@/activityPage/academicQuesAnswer/academicAnswerDetail'], resolve)
    },
    {
      name: 'OpenApp',
      title: '打开App',
      path: '/OpenApp',
      component: resolve => require(['@/wx/OpenApp'], resolve)
    },
    {
      name: 'wardRound',
      title: '肿瘤专科大查房',
      path: '/wardRound',
      component: resolve => require(['@/wardRound/index'], resolve)
    },
    {
      name: 'urology2023',
      title: '第三届中国泌尿肿瘤百强单位',
      path: '/urology2023',
      component: resolve => require(['@/activityPage/2023urology/urology2023'], resolve)
    },
    {
      name: 'urologyPage',
      title: '',
      path: '/urologyPage/:id',
      component: resolve => require(['@/activityPage/2023urology/urologyPage'], resolve)
    },
    {
      name: 'liveSpec',
      title: '公开课',
      path: '/liveSpec/:id',
      component: resolve => require(['./LiveSpec'], resolve)
    },
    {
      name: 'imagePreviewPage',
      title: '',
      path: '/imagePreviewPage',
      component: resolve => require(['./imagePreview'], resolve),
      meta: { pageViewStrategy: 'none' }
    },
    {
      name: 'bladeQuesAnswer',
      title: '刀客圈',
      path: '/bladeQuesAnswer',
      component: resolve => require(['@/activityPage/bladeCircle/index'], resolve)
    },
    {
      name: 'bladeAskQuest',
      title: '提问',
      path: '/bladeAskQuest',
      component: resolve => require(['@/activityPage/bladeCircle/bladeAskQuest'], resolve)
    },
    {
      name: 'bladeQuestDetail',
      title: '刀客圈',
      path: '/bladeQuestDetail/:id',
      component: resolve => require(['@/activityPage/bladeCircle/bladeQuestDetail'], resolve)
    },
    {
      name: 'bladeStaging',
      title: '肿瘤分期',
      path: '/bladeStaging',
      component: resolve => require(['@/activityPage/bladeCircle/bladeStaging'], resolve)
    },
    {
      name: 'ASCOTrace',
      title: 'ASCO追踪地图',
      path: '/ASCOTrace',
      component: resolve => require(['@/activityPage/2023ASCO/ASCOTrace'], resolve)
    },
    {
      name: 'ASCOacademicQuesAnswer',
      title: 'ASCO × ChatONC',
      path: '/ASCOacademicQuesAnswer',
      component: resolve => require(['@/activityPage/ascoAndchatonc/index'], resolve)
    },
    {
      name: 'ASCOacademicQuick',
      title: '快速问答',
      path: '/ASCOacademicQuick/:id',
      component: resolve => require(['@/activityPage/ascoAndchatonc/ASCOacademicQuick'], resolve)
    },
    {
      name: 'ASCOacademicAskQuest',
      title: '提问',
      path: '/ASCOacademicAskQuest/:id',
      component: resolve => require(['@/activityPage/ascoAndchatonc/ASCOacademicAskQuest'], resolve)
    },
    {
      name: 'ASCOacademicQuestDetail',
      title: 'ASCO × ChatONC',
      path: '/ASCOacademicQuestDetail/:id',
      component: resolve => require(['@/activityPage/ascoAndchatonc/ASCOacademicQuestDetail'], resolve)
    },
    {
      name: 'ASCOacademicAnswerDetail',
      title: 'ASCO × ChatONC',
      path: '/ASCOacademicAnswerDetail/:id',
      component: resolve => require(['@/activityPage/ascoAndchatonc/ASCOacademicAnswerDetail'], resolve)
    },
    {
      name: 'ASCOlabels',
      title: '',
      path: '/ASCOlabels/:id',
      component: resolve => require(['@/activityPage/ascoAndchatonc/ASCOlabels'], resolve)
    },
    {
      name: 'ASCOlabelsother',
      title: 'ASCO研究内容',
      path: '/ASCOlabelsother',
      component: resolve => require(['@/activityPage/ascoAndchatonc/ASCOlabels'], resolve)
    },
    {
      name: 'ASCOhotScreen',
      title: '热词筛选',
      path: '/ASCOhotScreen',
      component: resolve => require(['@/activityPage/ascoAndchatonc/ASCOhotScreen'], resolve)
    },
    {
      name: 'ASCOmoreRelevant',
      title: '更多相关研究',
      path: '/ASCOmoreRelevant/:id',
      component: resolve => require(['@/activityPage/ascoAndchatonc/ASCOmoreRelevant'], resolve)
    },
    {
      name: 'hundredQuesAnswer',
      title: '百发百应',
      path: '/hundredQuesAnswer',
      component: resolve => require(['@/activityPage/hundredQA/index'], resolve)
    },
    {
      name: 'hundredAskQuest',
      title: '提问',
      path: '/hundredAskQuest',
      component: resolve => require(['@/activityPage/hundredQA/hundredAskQuest'], resolve)
    },
    {
      name: 'hundredQuestDetail',
      title: '百问快答',
      path: '/hundredQuestDetail/:id',
      component: resolve => require(['@/activityPage/hundredQA/hundredQuestDetail'], resolve)
    },
    {
      name: 'doctorHomeView',
      title: '医师详情',
      path: '/doctorHome', //医生端： query中接doctorId；研值圈：query中researcherUuid，platFormType=2，auth，auth2
      component: resolve => require(['./doctorHomeView.vue'], resolve)
    },
    {
      name: 'newApplyMeeting',
      title: '新建申请',
      path: '/applyMeeting',
      component: resolve => require(['./newApplyMeeting.vue'], resolve)
    },
    {
      path: '/2023under35',
      name: 'Vote2023',
      title: '35under35',
      component: resolve => require(['./activityPage/2023under35/2023under35.vue'], resolve),
    },
    {
      path: '/2023under35Detail/:id',
      name: 'Vote2023Detail',
      title: '35under35',
      component: resolve => require(['./activityPage/2023under35/2023under35Detail.vue'], resolve),
    },
    {
      path: '/2024under35',
      name: 'Vote2024',
      title: '35under35',
      component: resolve => require(['./activityPage/2024under35/2024under35.vue'], resolve),
    },
    {
      path: '/2024under35Detail/:id',
      name: 'Vote2024Detail',
      title: '35under35',
      component: resolve => require(['./activityPage/2024under35/2024under35Detail.vue'], resolve),
    },
    {
      path: '/2025under35LiteratureInterpretation',
      name: 'LiteratureInterpretation',
      title: '第九届35 UNDER 35',
      component: resolve => require(['./activityPage/2025under35/LiteratureInterpretation.vue'], resolve),
    },
    {
      path: '/2025under35',
      name: 'Vote2025',
      title: '第九届35under35优秀青年肿瘤医生风采展示活动',
      component: resolve => require(['./activityPage/2025under35/vote.vue'], resolve),
    },
    {
      path: '/2025under35Detail/:id',
      name: 'Vote2025Detail',
      title: '第九届35under35优秀青年肿瘤医生风采展示活动',
      component: resolve => require(['./activityPage/2025under35/2025under35Detail.vue'], resolve),
    },
    {
      path: '/WclcHome',
      name: 'WclcHome',
      title: '',
      component: resolve => require(['./activityPage/WCLCandESMO/WclcHome.vue'], resolve),
    },
    {
      path: '/EsmoHome',
      name: 'EsmoHome',
      title: '',
      component: resolve => require(['./activityPage/WCLCandESMO/EsmoHome.vue'], resolve),
    },
    {
      name: 'dayAnswer',
      title: '每日答题',
      path: '/dayAnswer',
      component: resolve => require(['./pages/dailyAnswer/dayAnswer.vue'], resolve),
    },
    {
      name: 'otherDayAnswer',
      title: '每日答题',
      path: '/dayAnswer/:auth2',
      component: resolve => require(['./pages/dailyAnswer/dayAnswer.vue'], resolve),
    },
    {
      name: 'answerDetails',
      title: '每日一题',
      path: '/answerDetails/:id/:type',
      component: resolve => require(['./pages/dailyAnswer/answerDetails.vue'], resolve),
    },
    {
      name: 'answerReview',
      title: '答题回顾',
      path: '/answerReview',
      component: resolve => require(['./pages/dailyAnswer/answerReview.vue'], resolve),
    },
    {
      name: 'selectAreas',
      title: '答题领域选择',
      path: '/selectAreas',
      component: resolve => require(['./pages/dailyAnswer/selectAreas.vue'], resolve),
    },
    {
      name: 'ByzActivityDetail',
      title: '活动详情',
      path: '/ByzActivityDetail/:eventId/:paperId/:userAuth2/:dumb',
      component: resolve => require(['./activityPage/BYZ/ByzActivityDetail'], resolve),
    },
    {
      name: 'ByzPaperList',
      title: '试卷列表',
      path: '/ByzPaperList/:id', // 活动id
      component: resolve => require(['./activityPage/BYZ/ByzPaperList'], resolve),
    },
    {
      name: 'ByzExamDetail',
      title: '试题详情',
      path: '/ByzExamDetail/:eventId/:paperId',
      component: resolve => require(['./activityPage/BYZ/ByzExamDetail'], resolve),
    },
    {
      name: 'ByzQuestionBank',
      title: '答题详情',
      path: '/ByzQuestionBank/:eventId/:paperId',
      component: resolve => require(['./activityPage/BYZ/ByzQuestionBank.vue'], resolve),
      beforeRouteLeave: (to, from, next) => {
        if (window.Interval) {
          clearInterval(window.Interval)
        }
      },
    },
    {
      name: 'ByzQuestionRank',
      title: '排行榜',
      path: '/ByzQuestionRank/:eventId/:paperId',
      component: resolve => require(['./activityPage/BYZ/ByzQuestionRank.vue'], resolve),
    },
    {
      name: 'ByzOverallRank',
      title: '总排行榜',
      path: '/ByzOverallRank/:eventId',
      component: resolve => require(['./activityPage/BYZ/ByzOverallRank.vue'], resolve),
    },
    {
      name: 'myCollectNew',
      title: '我的收藏',
      path: '/myCollectNew',
      component: resolve => require(['./pages/myCollectList/myCollectNew.vue'], resolve),
    },
    {
      name: 'readHistory',
      title: '我的浏览',
      path: '/readHistory',
      component: resolve => require(['./pages/readHistory/index.vue'], resolve),
    },
    {
      name: 'sensorstest',
      title: '神策信息',
      path: '/sensorstest',
      component: resolve => require(['./pages/Sensors/sensorstest.vue'], resolve),
    },
    {
      name: 'nuohuaExportPatientList',
      title: '生命丽证 实例荟聚',
      path: '/nuohuaExportPatientList/:keyId',
      component: resolve => require(['./NuoHuaExportPatientList.vue'], resolve),
    },
    // 2024默克
    {
      name: '2024answerProjectHome',
      title: '结直肠癌全程管理学院实战营',
      path: '/2024answerProjectHome',
      component: resolve => require(['@/activityPage/2024answerProject/answerProjectHome'], resolve)
    },
    {
      name: '2024informationlist',
      title: '调研',
      path: '/2024informationlist',
      component: resolve => require(['@/activityPage/2024answerProject/informationlist'], resolve)
    },
    {
      name: '2024informationNewlist',
      title: '调研',
      path: '/2024informationNewlist',
      component: resolve => require(['@/activityPage/2024answerProject/informationNewlist'], resolve)
    },
    {
      name: 'mission',
      title: '结直肠癌全程管理学院实战营',
      path: '/mission/:month',
      component: resolve => require(['@/activityPage/2024answerProject/mission'], resolve)
    },
    {
      name: '2024caseAnswer',
      title: '课程答题',
      path: '/2024caseAnswer/:id',
      component: resolve => require(['@/activityPage/2024answerProject/caseAnswer'], resolve)
    },
    {
      name: '2024getCertificate',
      title: '结直肠癌全程管理学院实战营',
      path: '/2024getCertificate/:month',
      component: resolve => require(['@/activityPage/2024answerProject/getCertificate'], resolve)
    },
    {
      name: '2024resultRank',
      title: '学习榜单',
      path: '/2024resultRank',
      component: resolve => require(['@/activityPage/2024answerProject/resultRank'], resolve)
    },
    {
      name: '2024academicProgress',
      title: '学习进度',
      path: '/2024academicProgress',
      component: resolve => require(['@/activityPage/2024answerProject/academicProgress'], resolve)
    },
    {
      name: '2024answerDoc',
      title: '肿瘤医生',
      path: '/2024answerDoc/:id/:taskId',
      component: resolve => require(['@/activityPage/2024answerProject/newAnswerDoc'], resolve),
      meta: { pageViewStrategy: 'component' }
    },
    {
      name: '2024answerLive',
      title: '肿瘤医生',
      path: '/2024answerLive/:id/:taskId',
      component: resolve => require(['@/activityPage/2024answerProject/newAnswerLive'], resolve),
      meta: { pageViewStrategy: 'component' }
    },
    {
      name: 'MelanomaPage',
      title: '专栏详情',
      path: '/MelanomaPage/:id',
      component: resolve => require(['./activityPage/MelanomaPage.vue'], resolve),
    },
    {
      name: 'ApplyMelanoma',
      title: '申请加入',
      path: '/ApplyMelanoma/:unionId/:columnId',
      component: resolve => require(['./activityPage/ApplyMelanoma.vue'], resolve),
    },
    {
      name: '2024NewYear',
      title: '2024年新春活动',
      path: '/2024NewYear',
      component: resolve => require(['./activityPage/2024NewYear/index'], resolve),
    },
    {
      name: '2024NewYearOrderList',
      title: '2024年新春活动',
      path: '/2024NewYearOrderList',
      component: resolve => require(['./activityPage/2024NewYear/orderList'], resolve),
    }
    ,
    {
      name: '2024NewYearOrderDeatil',
      title: '2024年新春活动',
      path: '/2024NewYearOrderDeatil/:type',
      component: resolve => require(['./activityPage/2024NewYear/orderDeatil'], resolve),
    },
    {
      name: 'BCDoctorRoadway',
      title: 'BC医路行',
      path: '/BCDoctorRoadway',
      component: resolve => require(['./activityPage/BCDoctorRoadway/index'], resolve),
    },
    {
      name: 'BCDoctorRoadwayStudyCharts',
      title: '学习排行榜',
      path: '/BCDoctorRoadway/studyCharts',
      component: resolve => require(['./activityPage/BCDoctorRoadway/studyCharts'], resolve),
    },
    {
      name: 'BCDoctorRoadwayPersonalInfo',
      title: '学习中心',
      path: '/BCDoctorRoadway/personalInfo',
      component: resolve => require(['./activityPage/BCDoctorRoadway/personalInfo'], resolve),
    },
    {
      name: 'BCDoctorauthenticationApplySuccess',
      title: '申请成功',
      path: '/BCDoctorRoadway/applySuccess',
      component: resolve => require(['./activityPage/BCDoctorRoadway/applySuccess'], resolve),
    },
    {
      name: 'BCDoctorRoadwayMyFollow',
      title: '我的收藏',
      path: '/BCDoctorRoadway/myFollow',
      component: resolve => require(['./activityPage/BCDoctorRoadway/myFollow'], resolve),
    },
    {
      name: 'BCDoctorRoadwayReadHistory',
      title: '阅读历史',
      path: '/BCDoctorRoadway/readHistory',
      component: resolve => require(['./activityPage/BCDoctorRoadway/readHistory'], resolve),
    },
    {
      name: 'ambMsgList', //学习大使消息列表页面
      title: '我的消息',
      path: '/ambMsgList/:ambassadorId',//ambassadorId: 学习大使id
      component: resolve => require(['@/learnAmbassador/ambMsgList'], resolve)
    }
    ,
    {
      name: 'AILiterature',
      title: '文献速读',
      path: '/AILiterature',
      // component: resolve => require(['./pages/AILiterature/AILiterature'], resolve), // V0.3版本不用此页面了的，故换成新的。但是路由path还是保留，防止用户那还有旧的链接，让旧的path展示新的页面内容。
      component: resolve => require(['./pages/AILiterature/AILiteratureList'], resolve),
    }
    ,
    {
      name: 'AILiteratureOriginal',
      title: '文献速读',
      path: '/AILiteratureOriginal/:id',
      component: resolve => require(['./pages/AILiterature/AILiteratureOriginal'], resolve),
    },
    {
      name: 'AILiteratureDetails',
      title: '文献速读',
      path: '/AILiteratureDetails/:id',
      component: resolve => require(['./pages/AILiterature/AILiteratureDetails'], resolve),
    },
    {
      name: 'AILiteratureCollect',
      title: '我的收藏',
      path: '/AILiteratureCollect',
      component: resolve => require(['./pages/AILiterature/AILiteratureCollect'], resolve),
    },
    {
      name: 'AILiteratureCollectNew',
      title: '我的收藏',
      path: '/AILiteratureCollectNew',
      component: resolve => require(['./pages/AILiterature/AILiteratureCollectNew'], resolve),
    },
    {
      name: 'shareAILiterature',
      title: '文献速读',
      path: '/shareAILiterature/:id',
      component: resolve => require(['./pages/AILiterature/shareAILiterature'], resolve),
    },
    {
      name: 'BCDoctorRoadwayNavToPage',
      title: '',
      path: '/BCDoctorRoadway/navToPage',
      component: resolve => require(['./activityPage/BCDoctorRoadway/navToPage'], resolve),
    },
    {
      name: '2024ArkDestiny',
      title: 'Destiny命运的轨迹',
      path: '/2024ArkDestiny',
      component: resolve => require(['./activityPage/2024ArkDestiny'], resolve),
    },
    {
      name: 'ZlhAiHome',
      title: '智例汇·诊疗现状调研',
      path: '/ZlhAiHome',
      component: resolve => require(['./activityPage/learnAmb/ZLHAiNew/ZlhAiHome'], resolve),
    },
    {
      name: 'ZlhAiHomeV2',
      title: '调研专区',
      path: '/ZlhAiHomeV2',
      component: resolve => require(['./activityPage/learnAmb/ZLHAiV2/ZlhAiHomeV2'], resolve),
    },
    {
      name: 'ZlhAiHomeV2MsgList',
      title: '消息列表',
      path: '/ZlhAiHomeV2MsgList',
      component: resolve => require(['./activityPage/learnAmb/ZLHAiV2/msgList'], resolve),
    },
    {
      name: 'ZlhAiMyCase',
      title: '我的病例库',
      path: '/ZlhAiMyCase/:defalutTab', // defalutTab: 默认tab, 1:我的发布 2:草稿箱
      component: resolve => require(['./activityPage/learnAmb/ZLHAi/ZlhAiMyCase'], resolve),
    },
    {
      name: 'ZlhAiCaseDetail',
      title: '病例信息',
      path: '/ZlhAiCaseDetail/:id',
      component: resolve => require(['./activityPage/learnAmb/ZLHAi/ZlhAiCaseDetail'], resolve),
    },
    {
      name: 'AILiteratureSearch',
      title: '文献速读',
      path: '/AILiteratureSearch',
      component: resolve => require(['./pages/AILiterature/AILiteratureSearch'], resolve),
    },
    {
      name: 'AILiteratureList',
      title: '文献速读',
      path: '/AILiteratureList',
      component: resolve => require(['./pages/AILiterature/AILiteratureList'], resolve),
    },
    {
      name: 'TnmList',
      title: '肿瘤分期',
      path: '/tools/tnm/list',
      component: resolve => require(['./tools/tnm/list.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'TnmDetail',
      title: '肿瘤分期',
      path: '/tools/tnm/detail',
      component: resolve => require(['./tools/tnm/detail.vue'], resolve),
      meta: { isToolsPage: true, pageViewStrategy: 'component' }
    },
    {
      name: 'TnmAiDetail',
      title: '肺癌AI辅助诊断助手',
      path: '/tools/tnm/aiDetail/:id',
      component: resolve => require(['./tools/tnm/aiDetail.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'TnmAiBasis',
      title: '分期依据',
      path: '/tools/tnm/aiBasis/:id/:type/:index',
      component: resolve => require(['./tools/tnm/aiBasis.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'TnmAiHistory',
      title: '历史记录',
      path: '/tools/tnm/aiHistory',
      component: resolve => require(['./tools/tnm/aiHistory.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'TnmLungAdviceDetail',
      title: '',
      path: '/tools/tnm/adviceDetail/lung/:id',
      component: resolve => require(['./tools/tnm/lungAdviceDetail.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'TnmAdviceDetail',
      title: '',
      path: '/tools/tnm/adviceDetail/:id/:title',
      component: resolve => require(['./tools/tnm/adviceDetail.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'TnmAiPatient',
      title: '肺癌AI辅助诊断助手',
      path: '/tools/tnm/aiPatient/:id',
      component: resolve => require(['./tools/tnm/aiPatient.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'TnmAiBeiAn',
      title: '肺癌AI辅助诊断助手',
      path: '/ai/:id',
      component: resolve => require(['./tools/tnm/aiBeiAn.vue'], resolve),
      meta: { isToolsPage: false }
    },
    {
      name: 'TnmAllRecommendGuideList',
      title: 'CSCO&NCCN&ASCO治疗方案',
      path: '/tools/tnm/allRecommendGuideList',
      component: resolve => require(['./tools/tnm/allRecommendGuideList.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'patientBasis',
      title: '分期依据',
      path: '/tools/tnm/patient/patientBasis/:id/:type/:index',
      component: resolve => require(['./tools/tnm/patient/patientBasis.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'patientAdvice',
      title: '',
      path: '/tools/tnm/patient/patientAdvice/:id/:title',
      component: resolve => require(['./tools/tnm/patient/patientAdvice.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'CpgList',
      title: '临床指南',
      path: '/tools/cpg/list',
      component: resolve => require(['./tools/cpg/list.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'CpgDetail',
      title: '',// 接口拿到之后上报
      path: '/tools/cpg/detail',
      component: resolve => require(['./tools/cpg/detail.vue'], resolve),
      meta: { isToolsPage: true, pageViewStrategy: 'component', isNeedShowInfoComplete: true, infoCompleteData: {
        belong_page: '临床指南详情页',
        page_source: 'tools_cpg_detail'
      } }
    },
    {
      name: 'CpgPdfView',
      title: '',// 接口拿到之后上报
      path: '/tools/cpg/pdfview',
      component: resolve => require(['./tools/cpg/CpgPdfView.vue'], resolve),
      meta: { isToolsPage: true, pageViewStrategy: 'component' }
    },
    {
      name: 'CpgUpdate',
      title: '临床指南',
      path: '/tools/cpg/update',
      component: resolve => require(['./tools/cpg/update.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'TrjList',
      title: '肿瘤研究',
      path: '/tools/trj/list',
      component: resolve => require(['./tools/trj/list.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'TrjDetail',
      title: '肿瘤研究',
      path: '/tools/trj/detail',
      component: resolve => require(['./tools/trj/detail.vue'], resolve),
      meta: { isToolsPage: true, pageViewStrategy: 'component', isNeedShowInfoComplete: true, infoCompleteData: {
        belong_page: '肿瘤研究详情页',
        page_source: 'tools_trj_detail'
      } }
    },
    {
      name: 'TrjUpdate',
      title: '肿瘤研究',
      path: '/tools/trj/update',
      component: resolve => require(['./tools/trj/update.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'TrjSearch',
      title: '肿瘤研究',
      path: '/tools/trj/search',
      component: resolve => require(['./tools/trj/search.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'DrugsMain',
      title: '用药助手主页',
      path: '/tools/da/main',
      component: resolve => require(['./tools/da/main.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      // NRLD (National Reimbursement Drug List)
      name: 'NRLD',
      title: '国家医保药品目录',
      path: '/tools/da/nrld',
      component: resolve => require(['./tools/da/nrld.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'DaHome',
      title: 'R1满血版用药助手',
      path: '/tools/da/home',
      component: resolve => require(['./tools/da/home.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'DaHomeYear',
      title: '2022年新型抗肿瘤药物',
      path: '/tools/da/home/:year',
      component: resolve => require(['./tools/da/home.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'DaDetail',
      title: '',
      path: '/tools/da/detail/:id/:type',
      component: resolve => require(['./tools/da/detail.vue'], resolve),
      meta: { isToolsPage: true, pageViewStrategy: 'component', isNeedShowInfoComplete: true, infoCompleteData: {
        belong_page: '用药助手详情页',
        page_source: 'tools_da_detail'
      } }
    },
    {
      name: 'DaDetailYear',
      title: '',
      path: '/tools/da/detail/:id/:type/:year',
      component: resolve => require(['./tools/da/detail.vue'], resolve),
      meta: { isToolsPage: true, isNeedShowInfoComplete: true, infoCompleteData: {
        belong_page: '用药助手详情页',
        page_source: 'tools_da_detail'
      } }
    },
    {
      name: 'DaSearch',
      title: 'R1满血版用药助手',
      path: '/tools/da/search',
      component: resolve => require(['./tools/da/search.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'DaSearchYear',
      title: '2022年新型抗肿瘤药物',
      path: '/tools/da/search/:year',
      component: resolve => require(['./tools/da/search.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'DaDisease',
      title: '',
      path: '/tools/da/disease/:id',
      component: resolve => require(['./tools/da/disease.vue'], resolve),
      meta: { isToolsPage: true, pageViewStrategy: 'component' }
    },
    {
      name: 'DaDiseaseYear',
      title: '',
      path: '/tools/da/disease/:id/:year',
      component: resolve => require(['./tools/da/disease.vue'], resolve),
      meta: { isToolsPage: true, pageViewStrategy: 'component' }
    },
    {
      name: 'DaPreview',
      title: '2024年新型抗肿瘤药物',
      path: '/tools/da/preview/:type',
      component: resolve => require(['./tools/da/preview.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'DaPreviewYear',
      title: '2024年新型抗肿瘤药物',
      path: '/tools/da/preview/:type/:year',
      component: resolve => require(['./tools/da/preview.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'CmmHome',
      title: '化疗手册',
      path: '/tools/cmm/home',
      component: resolve => require(['./tools/cmm/2025/home.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'CmmHomeSub',
      title: '化疗手册',
      path: '/tools/cmm/homeSub/:id',
      component: resolve => require(['./tools/cmm/homeSub.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'CmmDetail',
      title: '化疗手册详情页',
      path: '/tools/cmm/detail',
      component: resolve => require(['./tools/cmm/detail.vue'], resolve),
      meta: { isToolsPage: true, isNeedShowInfoComplete: true, infoCompleteData: {
        belong_page: '化疗手册详情页',
        page_source: 'tools_cmm_detail'
      } }
    },
    {
      name: 'CmmCollection',
      title: '我的收藏',
      path: '/tools/cmm/collection',
      component: resolve => require(['./tools/cmm/collection.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'FormulaIndex',
      path: '/tools/formula',
      redirect: '/tools/formula/1',
      meta: { isToolsPage: true }
    },
    {
      name: 'FormulaTreatmentGeneral',
      title: '通用科室治疗公式',
      path: '/tools/formula/treatment/general',
      component: resolve => require(['./tools/formula/treatment/general/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_通用',
          page_source: 'tools_formula_general'
        }
      }
    },
    {
      name: 'FormulaTreatmentPediatrics',
      title: '儿科学科室治疗公式',
      path: '/tools/formula/treatment/pediatrics',
      component: resolve => require(['./tools/formula/treatment/pediatrics/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_儿科学',
          page_source: 'tools_formula_pediatrics'
        }
      }
    },
    {
      name: 'FormulaTreatmentCardio',
      title: '心血管科室治疗公式',
      path: '/tools/formula/treatment/cardio',
      component: resolve => require(['./tools/formula/treatment/cardio/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_心血管',
          page_source: 'tools_formula_cardio'
        }
      }
    },
    {
      name: 'FormulaTreatmentDiabetes',
      title: '糖尿病科室治疗公式',
      path: '/tools/formula/treatment/diabetes',
      component: resolve => require(['./tools/formula/treatment/diabetes/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_糖尿病',
          page_source: 'tools_formula_diabetes'
        }
      }
    },
    {
      name: 'FormulaTreatmentResp',
      title: '呼吸科室治疗公式',
      path: '/tools/formula/treatment/respiratory',
      component: resolve => require(['./tools/formula/treatment/respiratory/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_呼吸',
          page_source: 'tools_formula_resp'
        }
      }
    },
    {
      name: 'FormulaTreatmentNeurology',
      title: '神经病学科室治疗公式',
      path: '/tools/formula/treatment/neurology',
      component: resolve => require(['./tools/formula/treatment/neurology/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_神经病学',
          page_source: 'tools_formula_neurology'
        }
      }
    },
    {
      name: 'FormulaTreatmentGastro',
      title: '胃肠消化病学科室治疗公式',
      path: '/tools/formula/treatment/gastroenterology',
      component: resolve => require(['./tools/formula/treatment/gastroenterology/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_胃肠消化病学',
          page_source: 'tools_formula_gastro'
        }
      }
    },
    {
      name: 'FormulaTool',
      title: '',
      path: '/tools/formula/:type',
      component: resolve => require(['./tools/formula/formula.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'FormulaCollection',
      title: '我的收藏',
      path: '/tools/formula/collection/:type',
      component: resolve => require(['./tools/formula/collection.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'FormulaBsa',
      title: '体表面积计算公式（BSA）',
      path: '/tools/formula/treatment/bsa',
      component: resolve => require(['./tools/formula/treatment/bsa.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_体表面积计算公式（BSA）',
        page_source: 'tools_formula_bsa'
      } }
    },
    {
      name: 'FormulaBsaLegacy',
      path: '/tools/formula/bsa',
      redirect: '/tools/formula/treatment/bsa',
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_体表面积计算公式（BSA）',
        page_source: 'tools_formula_bsa'
      } }
    },
    {
      name: 'FormulaCarbo',
      title: '卡铂剂量计算公式',
      path: '/tools/formula/treatment/carbo',
      component:resolve => require(['./tools/formula/treatment/carbo.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_卡铂剂量计算公式',
        page_source: 'tools_formula_carbo'
      } }
    },

    {
      name: 'FormulaCarboLegacy',
      path: '/tools/formula/carbo',
      redirect: '/tools/formula/treatment/carbo',
      meta: { isToolsPage: true,infoCompleteData: {
        belong_page: '公式_卡铂剂量计算公式',
        page_source: 'tools_formula_carbo'
      } }
    },
    {
      name: 'FormulaCcr',
      title: '肌酐清除率计算公式',
      path: '/tools/formula/treatment/ccr',
      component: resolve => require(['./tools/formula/treatment/ccr.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_肌酐清除率计算公式（Ccr）',
        page_source: 'tools_formula_ccr'
      } }
    },
    {
      name: 'FormulaCcrLegacy',
      path: '/tools/formula/ccr',
      redirect: '/tools/formula/treatment/ccr',
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_肌酐清除率计算公式（Ccr）',
        page_source: 'tools_formula_ccr'
      } }
    },
    {
      name: 'FormulaBmi',
      title: '身体质量指数',
      path: '/tools/formula/evaluation/bmi',
      component: resolve => require(['./tools/formula/evaluation/BMICompute.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_身体质量指数（BMI）',
        page_source: 'tools_formula_bmi'
      } }
    },
    {
      name: 'FormulaBmiLegacy',
      path: '/tools/formula/bmi',
      redirect: '/tools/formula/evaluation/bmi',
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_身体质量指数（BMI）',
        page_source: 'tools_formula_bmi'
      } }
    },
    {
      name: 'DoctorToolsIndex',
      title: '医学工具',
      path: '/tools/DoctorToolsIndex',
      component: resolve => require(['./tools/DoctorToolsIndex.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'BED',
      title: 'BED计算公式',
      path: '/tools/formula/treatment/bed',
      component: resolve => require(['./tools/formula/treatment/bed.vue'], resolve),
      meta: { isToolsPage: true,infoCompleteData: {
        belong_page: '公式_BED计算公式',
        page_source: 'tools_formula_bed'
      } }
          },    
    {
      name: 'FormulaTreatmentOncology',
      title: '肿瘤学科室治疗公式',
      path: '/tools/formula/treatment/oncology',
      component: resolve => require(['./tools/formula/treatment/oncology/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_肿瘤学',
          page_source: 'tools_formula_oncology'
        }
      }
    },
    {
      name: 'FormulaTreatmentObstetrics',
      title: '产科科室治疗公式',
      path: '/tools/formula/treatment/obstetrics',
      component: resolve => require(['./tools/formula/treatment/obstetrics/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_产科',
          page_source: 'tools_formula_obstetrics'
        }
      }
    },
    {
      name: 'FormulaTreatmentTrauma',
      title: '创伤医学科室治疗公式',
      path: '/tools/formula/treatment/trauma',
      component: resolve => require(['./tools/formula/treatment/trauma/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_创伤医学',
          page_source: 'tools_formula_trauma'
        }
      }
    },
    {
      name: 'FormulaTreatmentAnesthesiology',
      title: '麻醉学科室治疗公式',
      path: '/tools/formula/treatment/anesthesiology',
      component: resolve => require(['./tools/formula/treatment/anesthesiology/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_麻醉学',
          page_source: 'tools_formula_anesthesiology'
        }
      }
    },
    {
      name: 'FormulaTreatmentEndocrinology',
      title: '内分泌学科室治疗公式',
      path: '/tools/formula/treatment/endocrinology',
      component: resolve => require(['./tools/formula/treatment/endocrinology/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_内分泌学',
          page_source: 'tools_formula_endocrinology'
        }
      }
    },
    {
      name: 'FormulaTreatmentHepatology',
      title: '肝脏病学科室治疗公式',
      path: '/tools/formula/treatment/hepatology',
      component: resolve => require(['./tools/formula/treatment/hepatology/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_肝脏病学',
          page_source: 'tools_formula_hepatology'
        }
      }
    },
    {
      name: 'FormulaTreatmentHematology',
      title: '血液学科室治疗公式',
      path: '/tools/formula/treatment/hematology',
      component: resolve => require(['./tools/formula/treatment/hematology/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_血液学',
          page_source: 'tools_formula_hematology'
        }
      }
    },
    {
      name: 'FormulaTreatmentRheumatology',
      title: '风湿免疫病科室治疗公式',
      path: '/tools/formula/treatment/rheumatology',
      component: resolve => require(['./tools/formula/treatment/rheumatology/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_风湿免疫病',
          page_source: 'tools_formula_rheumatology'
        }
      }
    },
    {
      name: 'FormulaTreatmentOrtho',
      title: '骨科科室治疗公式',
      path: '/tools/formula/treatment/orthopedics',
      component: resolve => require(['./tools/formula/treatment/orthopedics/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_骨科',
          page_source: 'tools_formula_ortho'
        }
      }
    },
    {
      name: 'FormulaTreatmentElectrolyte',
      title: '电解质科室治疗公式',
      path: '/tools/formula/treatment/electrolyte',
      component: resolve => require(['./tools/formula/treatment/electrolyte/index.vue'], resolve),
      meta: { 
        isToolsPage: true,
        infoCompleteData: {
          belong_page: '公式_电解质',
          page_source: 'tools_formula_electrolyte'
        }
      }
    },
    {
      name: 'SNSF',
      title: '低钠血症补钠量计算公式',
      path: '/tools/formula/treatment/snsf',
      component: resolve => require(['./tools/formula/treatment/snsf.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_低钠血症补钠量计算公式',
        page_source: 'tools_formula_snsf'
      } }
    },
    {
      name: 'Gfr',
      title: '肾小球滤过率（GFR）估算公式（CKD-EPI公式）',
      path: '/tools/formula/treatment/gfr',
      component: resolve => require(['./tools/formula/treatment/gfr.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_肾小球滤过率（GFR）估算公式（CKD-EPI公式）',
        page_source: 'tools_formula_gfr'
      } }
    },
    {
      name: 'BEDLegacy',
      path: '/tools/formula/bed',
      redirect: '/tools/formula/treatment/bed',
      meta: { isToolsPage: true,infoCompleteData: {
        belong_page: '公式_BED计算公式',
        page_source: 'tools_formula_bed'
      } }
    },
    {
      name: 'SNSFLegacy',
      path: '/tools/formula/snsf',
      redirect: '/tools/formula/treatment/snsf',
      meta: { isToolsPage: true,infoCompleteData: {
        belong_page: '公式_低钠血症补钠量计算公式',
        page_source: 'tools_formula_snsf'
      } }
    },
    {
      name: 'psStore',
      title: '肿瘤患者体力状况评分',
      path: '/tools/formula/psStore',
      redirect: '/tools/formula/evaluation/zpsStore',
      meta: { isToolsPage: true,infoCompleteData: {
        belong_page: '公式_肿瘤患者体力状况评分',
        page_source: 'tools_formula_zpsStore'
      } }
    },
    {
      name: 'zpsStore',
      title: 'ECOG体力状态评分(ZPS,5分法)',
      path: '/tools/formula/evaluation/zpsStore',
      component: resolve => require(['./tools/formula/evaluation/zpsStore.vue'], resolve),
      meta: { isToolsPage: true,infoCompleteData: {
        belong_page: '公式_ECOG体力状态评分(ZPS,5分法)',
        page_source: 'tools_formula_zpsStore'
      } }
    },
    {
      name: 'zpsStoreLegacy',
      path: '/tools/formula/zpsStore',
      redirect: '/tools/formula/evaluation/zpsStore',
      meta: { isToolsPage: true,infoCompleteData: {
        belong_page: '公式_ECOG体力状态评分(ZPS,5分法)',
        page_source: 'tools_formula_zpsStore'
      } }
    },
    {
      name: 'kpsStore',
      title: '体力状态评分(KPS,百分法)',
      path: '/tools/formula/evaluation/kpsStore',
      component: resolve => require(['./tools/formula/evaluation/kpsStore.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_体力状态评分(KPS,百分法)',
        page_source: 'tools_formula_kpsStore'
      } }
    },
    {
      name: 'kpsStoreLegacy',
      path: '/tools/formula/kpsStore',
      redirect: '/tools/formula/evaluation/kpsStore',
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_体力状态评分(KPS,百分法)',
        page_source: 'tools_formula_kpsStore'
      } }
    },
    {
      name: 'painGrading',
      title: '癌痛主诉疼痛分级法(Verbal Rating Scale,VRS)',
      path: '/tools/formula/evaluation/painGrading',
      component: resolve => require(['./tools/formula/evaluation/painGrading.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_癌痛主诉疼痛分级法(Verbal Rating Scale,VRS)',
        page_source: 'tools_formula_painGrading'
      } }
    },
    {
      name: 'painGradingLegacy',
      path: '/tools/formula/painGrading',
      redirect: '/tools/formula/evaluation/painGrading',
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_癌痛主诉疼痛分级法(Verbal Rating Scale,VRS)',
        page_source: 'tools_formula_painGrading'
      } }
    },
    {
      name: 'ctcae',
      title: '常见不良事件评价标准（CTCAE）5.0',
      path: '/tools/formula/evaluation/ctcae',
      component: resolve => require(['./tools/formula/evaluation/ctcae.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_常见不良事件评价标准（CTCAE）5.0',
        page_source: 'tools_formula_ctcae'
      } }
    },
    {
      name: 'Stepp',
      title: '早期绝经前激素受体阳性乳腺癌综合复发风险评分（STEPP评分）',
      path: '/tools/formula/evaluation/stepp',
      component: resolve => require(['./tools/formula/evaluation/stepp.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_早期绝经前激素受体阳性乳腺癌综合复发风险评分（STEPP评分）',
        page_source: 'tools_formula_stepp'
      } }
    },
    {
      name: 'Recist',
      title: '实体瘤的疗效评价标准（RECIST 1.1)',
      path: '/tools/formula/evaluation/recist',
      component: resolve => require(['./tools/formula/evaluation/recist.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_实体瘤的疗效评价标准（RECIST 1.1)',
        page_source: 'tools_formula_recist'
      } }
    },
    {
      name: 'PainWho',
      title: '疼痛分级-WHO疼痛分级标准',
      path: '/tools/formula/evaluation/painWho',
      component: resolve => require(['./tools/formula/evaluation/painWho.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_疼痛分级-WHO疼痛分级标准',
        page_source: 'tools_formula_painWho'
      } }
    },
    {
      name: 'PainNrs',
      title: '疼痛分级-数字分级评分法（NRS）',
      path: '/tools/formula/evaluation/painNrs',
      component: resolve => require(['./tools/formula/evaluation/painNrs.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_疼痛分级-数字分级评分法（NRS）',
        page_source: 'tools_formula_painNrs'
      } }
    },
    {
      name: 'PainVas',
      title: '视觉模拟评分法 (VAS)',
      path: '/tools/formula/evaluation/painVas',
      component: resolve => require(['./tools/formula/evaluation/painVas.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_视觉模拟评分法 (VAS)',
        page_source: 'tools_formula_painVas'
      } }
    },
    {
      name: 'PainFps',
      title: '面部表情评分量表 (FPS)',
      path: '/tools/formula/evaluation/painFps',
      component: resolve => require(['./tools/formula/evaluation/painFps.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_面部表情评分量表 (FPS)',
        page_source: 'tools_formula_painFps'
      } }
    },
    {
      name: 'Mirels',
      title: '病理性骨折风险评分系统（Mirels 评分系统）',
      path: '/tools/formula/evaluation/mirels',
      component: resolve => require(['./tools/formula/evaluation/mirels.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_病理性骨折风险评分系统（Mirels 评分系统）',
        page_source: 'tools_formula_mirels'
      } }
    },
    {
      name: 'GcRss',
      title: '中国人群胃癌风险评分系统（GC-RSS评分）',
      path: '/tools/formula/evaluation/gcRss',
      component: resolve => require(['./tools/formula/evaluation/gcRss.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_中国人群胃癌风险评分系统（GC-RSS评分）',
        page_source: 'tools_formula_gcRss'
      } }
    },
    {
      name: 'Crs',
      title: '结直肠癌肝转移预后风险评分（CRS评分）',
      path: '/tools/formula/evaluation/crs',
      component: resolve => require(['./tools/formula/evaluation/crs.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_结直肠癌肝转移预后风险评分（CRS评分）',
        page_source: 'tools_formula_crs'
      } }
    },
    {
      name: 'Nordlinger',
      title: '结直肠癌肝转移预后风险评分（Nordlinger评分）',
      path: '/tools/formula/evaluation/nordlinger',
      component: resolve => require(['./tools/formula/evaluation/nordlinger.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_结直肠癌肝转移预后风险评分（Nordlinger评分）',
        page_source: 'tools_formula_nordlinger'
      } }
    },
    {
      name: 'NsNrs',
      title: '营养风险筛查2002（NRS 2002 ）',
      path: '/tools/formula/evaluation/nsNrs',
      component: resolve => require(['./tools/formula/evaluation/nsNrs.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_营养风险筛查2002（NRS 2002 ）',
        page_source: 'tools_formula_nsNrs'
      } }
    },
    {
      name: 'NsMust',
      title: '营养不良通用筛查工具（MUST）',
      path: '/tools/formula/evaluation/nsMust',
      component: resolve => require(['./tools/formula/evaluation/nsMust.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_营养不良通用筛查工具（MUST）',
        page_source: 'tools_formula_nsMust'
      } }
    },
    {
      name: 'PraBraden',
      title: '压疮危险评估量-Braden量表',
      path: '/tools/formula/evaluation/praBraden',
      component: resolve => require(['./tools/formula/evaluation/praBraden.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_压疮危险评估量-Braden量表',
        page_source: 'tools_formula_praBraden'
      } }
    },
    {
      name: 'PraNorton',
      title: '压疮危险评估量-Norton量表',
      path: '/tools/formula/evaluation/praNorton',
      component: resolve => require(['./tools/formula/evaluation/praNorton.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_压疮危险评估量-Norton量表',
        page_source: 'tools_formula_praNorton'
      } }
    },
    {
      name: 'Cts5',
      title: '临床治疗5年后风险评分（CTS5）',
      path: '/tools/formula/evaluation/cts5',
      component: resolve => require(['./tools/formula/evaluation/cts5.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_临床治疗5年后风险评分（CTS5）',
        page_source: 'tools_formula_cts5'
      } }
    },
    {
      name: 'Ctcae6',
      title: '常见不良事件评价标准（CTCAE）6.0',
      path: '/tools/formula/evaluation/ctcae6',
      component: resolve => require(['./tools/formula/evaluation/ctcae6.vue'], resolve),
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_常见不良事件评价标准（CTCAE）6.0',
        page_source: 'tools_formula_ctcae6'
      } }
    },
    {
      name: 'ctcaeLegacy',
      path: '/tools/formula/ctcae',
      redirect: '/tools/formula/evaluation/ctcae',
      meta: { isToolsPage: true, infoCompleteData: {
        belong_page: '公式_常见不良事件评价标准（CTCAE）5.0',
        page_source: 'tools_formula_ctcae'
      } }
    },
    {
      name: 'aiDailyNewsList', //学习大使ai每日早报
      title: 'AI每日早报',
      path: '/aiDailyNewsList/:ambassadorId',//ambassadorId: 学习大使id
      component: resolve => require(['@/learnAmbassador/aiDailyNewsList'], resolve)
    },
    {
      name: 'aiDailyNewsDetail', //学习大使ai每日早报详情
      title: '早报详情',
      path: '/aiDailyNewsDetail/:id/:ambassadorId',//id:早报对应的id  ambassadorId: 学习大使id
      component: resolve => require(['@/learnAmbassador/aiDailyNewsDetail'], resolve)
    },
    {
      name: '2024wclc',
      title: '2024WCLC大会',
      path: '/2024wclc',
      component: resolve => require(['./activityPage/2024WCLC/index.vue'], resolve),
    },
    {
      name: '2024wclcHot',
      title: '2024WCLC最受关注的研究',
      path: '/2024wclcHot',
      component: resolve => require(['./activityPage/2024WCLC/hotBillboard.vue'], resolve),
    },
    {
      name: '2024esmo',
      title: '2024 ESMO大会',
      path: '/2024esmo',
      component: resolve => require(['./activityPage/2024ESMO/index.vue'], resolve),
    },
    {
      name: '2024esmoHot',
      title: '2024ESMO最受关注中国研究',
      path: '/2024esmoHot',
      component: resolve => require(['./activityPage/2024ESMO/hotBillboard.vue'], resolve),
    },
    {
      name: '2024csco',
      title: '学术季&迎国庆',
      path: '/2024csco',
      component: resolve => require(['./activityPage/2024CSCO/index'], resolve),
    },
    {
      name: '2024DoctorQuestionnaire',
      title: '2024知识获取现状调研',
      path: '/2024DoctorQuestionnaire',
      component: resolve => require(['./activityPage/2024DoctorQuestionnaire/DoctorQuestionnaire.vue'], resolve),
    },
    {
      name: 'MyCase',
      title: '我的病例库',
      path: '/caseSquare/mycase/:active',
      component: resolve => require(['./CaseSquare/MyCase.vue'], resolve),
    },
    {
      name: 'CaseSquare',
      title: '肿瘤医生病例库',
      path: '/caseSquare/list',
      component: resolve => require(['./CaseSquare/CaseSquare.vue'], resolve),
    },
    {
      name: '2024Summary',
      title: '肿瘤医生2024年个人年度报告',
      path: '/2024Summary',
      component: resolve => require(['./activityPage/2024Summary/index.vue'], resolve),
    },
    {
      name: '2024SummaryReport',
      title: '肿瘤医生2024年个人年度报告',
      path: '/2024SummaryReport',
      component: resolve => require(['./activityPage/2024Summary/report.vue'], resolve),
    },
    {
      name: '2024SummaryGift',
      title: '年运签',
      path: '/2024SummaryGift',
      component: resolve => require(['./activityPage/2024Summary/gift.vue'], resolve),
    },
    {
      name: '2024SummaryMyGift',
      title: '我的奖品',
      path: '/2024SummaryMyGift',
      component: resolve => require(['./activityPage/2024Summary/mygift.vue'], resolve),
    },
    {
      name: '2024NoSummary',
      title: '肿瘤医生2024年个人年度报告',
      path: '/2024NoSummary',
      component: resolve => require(['./activityPage/2024Summary/noSummary.vue'], resolve),
    },
    {
      name: '2025CmmHomeSub',
      title: '',
      path: '/tools/cmm/homeSub/2025/:id',
      component: resolve => require(['./tools/cmm/2025/homeSub.vue'], resolve),
      meta: { isToolsPage: true, pageViewStrategy: 'component' }
    },
    {
      name: '2025CmmDetail',
      title: '',
      path: '/tools/cmm/detail/2025',
      component: resolve => require(['./tools/cmm/2025/detail.vue'], resolve),
      meta: { isToolsPage: true, pageViewStrategy: 'component', isNeedShowInfoComplete: true, infoCompleteData: {
        belong_page: '化疗手册详情页',
        page_source: 'tools_cmm_detail'
      } }
    },
    {
      name: '2025CmmCollection',
      title: '我的收藏',
      path: '/tools/cmm/collection/2025',
      component: resolve => require(['./tools/cmm/2025/homeSub.vue'], resolve),
      meta: { isToolsPage: true }
    },
    {
      name: 'medSeekInterpret',
      title: 'MedSeek解读',
      path: '/medSeekInterpret',
      component: resolve => require(['./AI/DocInterpret/MedSeekInterpret.vue'], resolve),
    },
    {
      name: 'medSeekInterpretPreview',
      title: 'MedSeek解读',
      path: '/medSeekInterpret/:rid',
      props: true, // 将路由参数作为 props 传递给组件
      component: resolve => require(['./AI/preview.vue'], resolve),
    },
    {
      name: 'aiMedSeek',
      title: 'MedSeek.Ai',
      path: '/MedSeek/:version/:entry(search_box|guide_tool)/:uid?/:rid?',
      component: resolve => require(['./AI/index.vue'], resolve),
      props: true
    },
    {
      name: 'aiMedSeekTnm',
      title: 'MedSeek.Ai',
      path: '/MedSeek/:version/:entry(tnm_tool)/:keyword?',
      component: resolve => require(['./AI/index.vue'], resolve),
      props: (route) => ({
        version: route.params.version,
        entry: 'tnm_tool',
        keyword: route.params.keyword || route.query.keyword,
      })
    },
    {
      name: 'aiMedSeekRedirect',
      title: '',
      path: '/MedSeek/:uid/:rid',
      redirect: to => `/MedSeek/v2/search_box/${to.params.uid}/${to.params.rid}`,
    },
    {
      name: 'aiMedSeekPreview',
      title: 'MedSeek.Ai',
      path: '/MedSeek/:rid',
      props: true, // 将路由参数作为 props 传递给组件
      component: resolve => require(['./AI/preview.vue'], resolve),
    },
    {
      name: 'guWuXinShengHome',
      title: '骨舞新声·将才工程',
      path: '/gwxshome',
      props: true, // 将路由参数作为 props 传递给组件
      component: resolve => require(['./activityPage/2025GuWuXinSheng/home.vue'], resolve),
    },
    {
      name: 'guWuXinShengList',
      title: '骨舞新声·将才工程',
      path: '/gwxslist',
      props: true, // 将路由参数作为 props 传递给组件
      component: resolve => require(['./activityPage/2025GuWuXinSheng/list.vue'], resolve),
    },
    // 2025默克
    {
      name: '2025answerProjectHome',
      title: '结直肠癌全程管理学院实战营',
      path: '/2025answerProjectHome',
      component: resolve => require(['@/activityPage/2025answerProject/answerProjectHome'], resolve)
    },
    {
      name: '2025answerProjectMission',
      title: '结直肠癌全程管理学院实战营',
      path: '/2025answerProjectMission',
      component: resolve => require(['@/activityPage/2025answerProject/mission'], resolve)
    },
    {
      name: '2025answerProjectMissionDetail',
      title: '结直肠癌全程管理学院实战营',
      path: '/2025answerProjectMissionDetail/:id',
      component: resolve => require(['@/activityPage/2025answerProject/missionDetail'], resolve)
    },
    {
      name: '2025answerProjectProcess',
      title: '学习进度',
      path: '/2025answerProjectProcess',
      component: resolve => require(['@/activityPage/2025answerProject/process'], resolve)
    },
    {
      name: '2025answerProjectDownloadCertificate',
      title: '学习进度',
      path: '/2025answerProjectDownloadCertificate',
      component: resolve => require(['@/activityPage/2025answerProject/downloadCertificate'], resolve)
    },
    {
      name: '2025answerProjectResultRank',
      title: '学习榜单',
      path: '/2025answerProjectResultRank',
      component: resolve => require(['@/activityPage/2025answerProject/resultRank'], resolve)
    },
    {
      name: '2025answerProjectLive',
      title: '肿瘤医生',
      path: '/2025answerProjectLive/:id/:taskId',
      component: resolve => require(['@/activityPage/2025answerProject/answerLive'], resolve)
    },
    {
      name: '2025answerProjectDoc',
      title: '肿瘤医生',
      path: '/2025answerProjectDoc/:id/:taskId',
      component: resolve => require(['@/activityPage/2025answerProject/answerDoc'], resolve)
    },
    {
      name: '2025answerProjectCase',
      title: '课程答题',
      path: '/2025answerProjectCase/:id',
      component: resolve => require(['@/activityPage/2025answerProject/answerCase'], resolve)
    },
    {
      name: 'examStarPay',
      title: '职考',
      path: '/examStar/pay',
      component: resolve => require(['@/examStar/pay'], resolve)
    },
    {
      name: 'examStarHome',
      title: '职考',
      path: '/examStar/home',
      component: resolve => require(['@/examStar/home'], resolve)
    },
    {
      name: 'examStarTemporary',
      title: '',
      path: '/examStar/temporary',
      component: resolve => require(['@/examStar/temporary'], resolve)
    },
    {
      name: 'examStarStatus',
      title: '支付状态',
      path: '/examStar/status',
      component: resolve => require(['@/examStar/status'], resolve)
    },
    {
      name: 'medSeekColumn',
      title: '骨转移规范化Ai小助手',
      path: '/medSeekColumn',
      component: resolve => require(['./AI/Column/MedSeekColumn.vue'], resolve),
    },
    {
      name: 'medSeekColumnPreview',
      title: '骨转移规范化Ai小助手',
      path: '/medSeekColumnPreview/:rid',
      props: true, // 将路由参数作为 props 传递给组件
      component: resolve => require(['./AI/preview.vue'], resolve),
    },
    {
      name: 'columnAI',
      title: '专栏详情', //新专栏详情
      path: '/columnAI/:id',
      component: resolve => require(['./ColumnAI.vue'], resolve)
    },
    {
      name: 'VoiceOfChest',
      title: 'Voice of Chest',
      path: '/VoiceOfChest',
      component: resolve => require(['./activityPage/2025VoiceOfChest.vue'], resolve),
    },
    {
      name: '2025TakedaAnsweringCompetition',
      title: '观点对对碰',
      path: '/2025TakedaAnsweringCompetition/:id',
      component: resolve => require(['./activityPage/2025Takeda/answeringCompetition.vue'], resolve),
    },
    {
      name: 'SignProtocol',
      title: '签署姓名',
      // projectId:项目ID
      // signAgreementType: 签署协议类型  1 项目协议（ai病历夹患者协议） 2问卷协议 3 ppt协议
      // patientId: 患者ID(signAgreementType为1时必须对应患者ID(需urlencode)；signAgreementType为其他值时传0，占位用)
      // relatedInfo: signAgreementType为1时传0（无意义，只是占位）；signAgreementType为2时对应问卷ID ；signAgreementType为3时对应PPT链接(需urlencode)；
      path: '/signProtocol/:projectId/:signAgreementType/:patientId/:relatedInfo',
      component: resolve => require(['./activityPage/SignQuestnaire/signProtocol.vue'], resolve),
    },
    {
      name: 'CaseInvBefSign',
      title: '填写问卷',
      path: '/CaseInvBefSign/:id/:projectId', // id:问卷ID   projectId:项目ID
      component: resolve => require(['@/activityPage/SignQuestnaire/CaseInvBefSign.vue'], resolve),
    },
    {
      name: 'ProtocolPreview',
      title: '预览协议',
      // projectId:项目ID
      // signAgreementType: 签署协议类型  1 项目协议（ai病历夹患者协议） 2问卷协议 3 ppt协议
      // patientId: 患者ID(signAgreementType为1时必须对应患者ID(需urlencode)；signAgreementType为其他值时传0，占位用)
      // relatedInfo: signAgreementType为1时传0（无意义，只是占位）；signAgreementType为2时对应问卷ID ；signAgreementType为3时对应PPT链接(需urlencode)；
      path: '/protocolPreview/:projectId/:signAgreementType/:patientId/:relatedInfo',
      component: resolve => require(['@/activityPage/SignQuestnaire/protocolPreview.vue'], resolve),
    },
    {
      name: 'PfizerSciHome',
      title: '辉瑞研发开放创新中心',
      path: '/PfizerSciHome/:type', //type 1:辉瑞科研
      component: resolve => require(['@/activityPage/Pfizer/PfizerSciHome.vue'], resolve),
    },
    {
      name: 'PfizerCommunityPublish',
      title: '发布新动态',
      path: '/PfizerCommunityPublish/:projectCode',
      component: resolve => require(['@/activityPage/Pfizer/PfizerCommunityPublish.vue'], resolve),
    },
    {
      name: 'PfizerCommunityList',
      title: '辉瑞研发开放创新中心',
      path: '/PfizerCommunityList/:projectCode',
      component: resolve => require(['@/activityPage/Pfizer/PfizerCommunityList.vue'], resolve),
    },
    {
      name: 'PfizerCommunityDetail',
      title: '辉瑞研发开放创新中心',
      path: '/PfizerCommunityDetail/:id/:projectCode',
      component: resolve => require(['@/activityPage/Pfizer/PfizerCommunityDetail.vue'], resolve),
    },
    {
      name: 'PfizerEventArticleList',
      title: '辉瑞研发开放创新中心',
      path: '/PfizerEventArticleList/:id/:projectCode', // id:专题ID   projectCode:项目号
      component: resolve => require(['@/activityPage/Pfizer/PfizerEventArticleList.vue'], resolve),
    },
    {
      name: 'PfizerWenJuan',
      title: '辉瑞研发开放创新中心-能力认证',
      path: '/PfizerWenJuan/:questionnaireId',
      component: resolve => require(['@/activityPage/Pfizer/PfizerWenJuan.vue'], resolve),
    },
    {
      name: 'PfizerDataBase',
      title: '资料库',
      path: '/pfizerDataBase',
      component: resolve => require(['@/learnAmbassador/pfizer/pfizerDataBase'], resolve)
    },
    {
      name: 'PfizerDataBaseList',
      title: '资料列表',
      path: '/pfizerDataBaseList',
      component: resolve => require(['@/learnAmbassador/pfizer/pfizerDataBaseList'], resolve)
    },
    {
      name: 'PfizerFilePreview',
      title: '文件预览',
      path: '/pfizerFilePreview',
      component: resolve => require(['@/learnAmbassador/pfizer/pfizerFilePreview'], resolve)
    },
    {
      name: 'shuoWenJieYaoHome',
      title: '说文解药',
      path: '/swjyhome',
      props: true, // 将路由参数作为 props 传递给组件
      component: resolve => require(['./activityPage/2025shuowenjieyao/home.vue'], resolve),
    },
    {
      name: 'shuoWenJieYaoList',
      title: '说文解药',
      path: '/swjylist',
      props: true, // 将路由参数作为 props 传递给组件
      component: resolve => require(['./activityPage/2025shuowenjieyao/list.vue'], resolve),
    },
    {
      name: '2025Summary',
      title: '肿瘤医生2025年个人年度报告',
      path: '/2025Summary',
      component: resolve => require(['./activityPage/2025Summary/index.vue'], resolve),
    },
    {
      name: '2025SummaryGift',
      title: '年运签',
      path: '/2025SummaryGift',
      component: resolve => require(['./activityPage/2025Summary/gift.vue'], resolve),
    },
    {
      name: '2025SummaryReport',
      title: '肿瘤医生2025年个人年度报告',
      path: '/2025SummaryReport',
      component: resolve => require(['./activityPage/2025Summary/report.vue'], resolve),
    },
    {
      name: '2025SummaryMyGift',
      title: '我的奖品',
      path: '/2025SummaryMyGift',
      component: resolve => require(['./activityPage/2025Summary/mygift.vue'], resolve),
    },
    {
      name: '2025NoSummary',
      title: '肿瘤医生2025年个人年度报告',
      path: '/2025NoSummary',
      component: resolve => require(['./activityPage/2025Summary/noSummary.vue'], resolve),
    },
    {
      name: 'medSeekBMSColumn',
      title: 'MedSeek',
      path: '/medSeekBMSColumn',
      component: resolve => require(['./AI/Column/MedSeekBMSColumn.vue'], resolve),
    },
    {
      name: 'bmsDocList',
      title: '肿瘤医生',
      path: '/bmsDocList',
      component: resolve => require(['./activityPage/2025BMS/docList.vue'], resolve),
    },
    {
      name: 'aiMedSeekBMSPreview',
      title: 'MedSeek',
      path: '/aiMedSeekBMSPreview/:rid',
      props: true, // 将路由参数作为 props 传递给组件
      component: resolve => require(['./AI/bmsPreview.vue'], resolve),
    },
    {
      path: '/onco-live/sign/:key',
      name: 'OncoLiveSign',
      title:'协议签署中心',
      component: resolve => require(['./OncoLive/OncoLiveSign.vue'], resolve)
    },
     {
      name: 'SlhcCase',
      title: '病例知识库',
      path: '/caseSquare/SlhcCase',
      component: resolve => require(['./CaseSquare/SlhcCase.vue'], resolve),
    },
  ],
}
